import React, { useCallback, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db, auth, storage } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signOut
} from "firebase/auth";

import { where,  onSnapshot,   runTransaction  } from "firebase/firestore";


import {
  setDoc,
  doc,
  addDoc,
  query,
  getDocs,
  updateDoc,
  deleteDoc,
  collection,
  serverTimestamp,
  orderBy,
  limit,
} from "firebase/firestore";


import { getDownloadURL, ref, uploadBytesResumable, listAll } from "firebase/storage";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "./adminpanel.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Eye, EyeOff } from "lucide-react";



import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";




import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);






const AdminPanel = () => {

const [sellQuantity, setSellQuantity] = useState(1); // ✅ quantity to sell

  const [selectedOption, setSelectedOption] = useState("createAccount");

  // Create account form states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [nameWithInitial, setNameWithInitial] = useState("");
  const [companyname, setCompanyname] = useState("");
  const [address, setAddress] = useState("");
  const [nicPassport, setNicPassport] = useState("");
  const [contactNo, setContactNo] = useState("");

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);


  // Dropdown toggle state
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const toggleUserDropdown = () => setIsUserDropdownOpen((prev) => !prev);


 // Dropdown toggle state
  const [  isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);
  const toggleProductDropdown = () => setIsProductDropdownOpen((prev) => !prev);



  // All users fetched
  const [groupedUsers, setGroupedUsers] = useState({});


const [filterEmail, setFilterEmail] = useState("");

  const [purchasedItems, setPurchasedItems] = useState([]);
  const [filteredPurchases, setFilteredPurchases] = useState([]);
  const [selectedPurchase, setSelectedPurchase] = useState(null);




// download reports in update customer payments ////

const [reportMonth, setReportMonth] = useState("");
const [reportYear, setReportYear] = useState("");
const [reportDate, setReportDate] = useState("");

const [reportFilteredData, setReportFilteredData] = useState([]);




  // Logout function
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };





  // Create customer account
  const createAccount = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      await setDoc(doc(db, "users", userId), {
        email,
        role,
        nameWithInitial,
        companyname,
        address,
        nicPassport,
        contactNo,
      });

      toast.success("User created successfully!");
      setEmail("");
      setPassword("");
      setRole("");
      setNameWithInitial("");
      setCompanyname("");
      setAddress("");
      setNicPassport("");
      setContactNo("");
    } catch (error) {
      console.error("Error creating user:", error.message);
      toast.error(error.message);
    }
  };

  // Fetch all users
  const fetchAllUsers = useCallback(async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "users"));
      const users = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Group users by role
      const grouped = users.reduce((acc, user) => {
        const userRole = user.role || "Unassigned";
        if (!acc[userRole]) acc[userRole] = [];
        acc[userRole].push(user);
        return acc;
      }, {});

      setGroupedUsers(grouped);
    } catch (error) {
      console.error("Error fetching users:", error.message);
      toast.error("Error fetching users");
    }
  }, []);

  // Automatically fetch users when needed
  useEffect(() => {
    if (selectedOption === "viewAllUsers") {
      fetchAllUsers();
    }
  }, [selectedOption, fetchAllUsers]);

  // Render grouped users
  const renderUsersByRole = () => {
    return Object.keys(groupedUsers).map((role) => (
      <div key={role} className="user-group">
        <h2 className="role-title">{role.charAt(0).toUpperCase() + role.slice(1)}s</h2>
        <table className="user-table">
          <thead>
            <tr>
              <th>Name with Initials</th>
              <th>Email</th>
              <th>Contact No</th>
              <th>Company</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {groupedUsers[role].map((user) => (
              <tr key={user.id}>
                <td>{user.nameWithInitial}</td>
                <td>{user.email}</td>
                <td>{user.contactNo}</td>
                <td>{user.companyname}</td>
                <td>{user.address}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ));
  };




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Fetch all users from Firestore
// ==============================
const fetchAllUsersToView = useCallback(async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "users")); // ✅ Correct Firestore path
    const users = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Group users by role for display
    const grouped = users.reduce((acc, user) => {
      const userRole = user.role || "Unassigned";
      if (!acc[userRole]) acc[userRole] = [];
      acc[userRole].push(user);
      return acc;
    }, {});

    setGroupedUsers(grouped);
  } catch (error) {
    console.error("Error fetching users:", error.message);
    toast.error("Error fetching users");
  }
}, []);



useEffect(() => {
  if (selectedOption === "viewAllUsers") {
    fetchAllUsersToView();
  }
}, [selectedOption, fetchAllUsers]);





/////////////////////////////////////////////////////////////////////////////////////////////////////////
 const [editableUsers, setEditableUsers] = useState([]);
  const [editingUserId, setEditingUserId] = useState(null);

  // Fetch all users
  const fetchUsers = useCallback(async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "users"));
      const users = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setEditableUsers(users);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  }, []);

  useEffect(() => {
    if (selectedOption === "editUser") {
      fetchUsers();
    }
  }, [selectedOption, fetchUsers]);

  // Handle input change
  const handleEditChange = (id, field, value) => {
    setEditableUsers((prev) =>
      prev.map((user) =>
        user.id === id ? { ...user, [field]: value } : user
      )
    );
  };

  // Edit button click
  const handleEditClick = (id) => {
    setEditingUserId(id);
  };

  // Cancel edit
  const handleCancelClick = () => {
    setEditingUserId(null);
    fetchUsers(); // refresh to revert unsaved changes
  };

  // Save updated user
  const handleSaveUser = async (id) => {
    const updatedUser = editableUsers.find((user) => user.id === id);
    try {
      const userRef = doc(db, "users", id);
      await updateDoc(userRef, {
        nameWithInitial: updatedUser.nameWithInitial,
        companyname: updatedUser.companyname,
        address: updatedUser.address,
        nicPassport: updatedUser.nicPassport,
        contactNo: updatedUser.contactNo,
        
      });
      setEditingUserId(null);
      alert("User updated successfully!");
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Failed to update user");
    }
  };

  // Delete user
  const handleDeleteUser = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await deleteDoc(doc(db, "users", id));
        setEditableUsers((prev) => prev.filter((user) => user.id !== id));
        alert("User deleted successfully!");
      } catch (error) {
        console.error("Error deleting user:", error);
        alert("Failed to delete user");
      }
    }
  };



//////////////////////////////////  Product purchasing ////////////////////////////////////////////

  const [customerName, setCustomerName] = useState("");
  const [company, setCompany] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [advancePayment, setAdvancePayment] = useState("");
  const [installmentMonths, setInstallmentMonths] = useState("");
  const [eachInstallment, setEachInstallment] = useState("");
  const [remark, setRemark] = useState("");
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [productCode, setProductCode] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [date, setDate] = useState("");


const [finalAmount, setFinalAmount] = useState(0);

useEffect(() => {
  const total = Number(productPrice || 0) * Number(sellQuantity || 0);
  setFinalAmount(total);
}, [productPrice, sellQuantity]);





// 📅 Set today's date as default
useEffect(() => {
  const today = new Date().toISOString().split("T")[0];
  setDate(today);
}, []);

  // 🧾 Fetch last invoice number and generate new one
  useEffect(() => {
    const fetchInvoice = async () => {
      const q = query(collection(db, "purchased_products"), orderBy("createdAt", "desc"), limit(1));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const last = snapshot.docs[0].data();
        const lastNum = parseInt(last.invoiceNumber) || 0;
        const nextNum = (lastNum + 1).toString().padStart(3, "0");
        setInvoiceNumber(nextNum);
      } else {
        setInvoiceNumber("001");
      }
    };
    fetchInvoice();
  }, []);




useEffect(() => {
  const q = collection(db, "new_products");

  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    const products = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setProductList(products);
  });

  // Cleanup listener
  return () => unsubscribe();
}, []);






const [selectedProductId, setSelectedProductId] = useState(null);


// ================= PRODUCT CHANGE =================
const handleProductChange = (e) => {
  const selectedName = e.target.value;
  setSelectedProduct(selectedName);

  const product = productList.find((p) => p.productName === selectedName);

  if (product) {
    setSelectedProductId(product.id);
    setProductCode(product.productCode);
    setProductPrice(product.sellingPrice);
  }
};








// ================= QUANTITY CHANGE =================
const handleQuantityChange = (e) => {
  const qty = Number(e.target.value);

  if (!productCode) {
    setSellQuantity(qty);
    return;
  }

  // all same product code stock
  const sameProducts = productList.filter(
    (p) => p.productCode === productCode
  );

  const totalQty = sameProducts.reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0
  );

  if (qty > totalQty) {
    alert(`Only ${totalQty} items available`);
    return;
  }

  setSellQuantity(qty);
};










// ================= HANDLE ADD PRODUCT =================
const handleAddProduct = async (e) => {
  e.preventDefault();

  if (!productCode) {
    alert("Please select a product");
    return;
  }

  const sellQty = Number(sellQuantity);

  try {
    await runTransaction(db, async (transaction) => {
      // get all same product code records FIFO
      const q = query(
        collection(db, "new_products"),
        where("productCode", "==", productCode),
        orderBy("createdAt", "asc")
      );

      const snapshot = await getDocs(q);

      if (snapshot.empty) throw new Error("Product not found");

      let productDocs = [];
      let totalAvailable = 0;

      snapshot.forEach((docSnap) => {
        const data = docSnap.data();
        const qty = Number(data.quantity || 0);

        if (qty > 0) {
          productDocs.push({
            id: docSnap.id,
            ref: doc(db, "new_products", docSnap.id),
            data,
            qty,
          });

          totalAvailable += qty;
        }
      });

      if (totalAvailable < sellQty) {
        throw new Error(`Only ${totalAvailable} items available`);
      }

      // deduct stock FIFO
      let remaining = sellQty;

      for (const item of productDocs) {
        if (remaining <= 0) break;

        let deductQty = Math.min(item.qty, remaining);
        let newQty = item.qty - deductQty;

        transaction.update(item.ref, {
          quantity: newQty,
          sold: Number(item.data.sold || 0) + deductQty,
        });

        remaining -= deductQty;
      }





      
 // create invoice
      const purchaseRef = doc(collection(db, "purchased_products"));

      transaction.set(purchaseRef, {
        invoiceNumber,
        date,
        customerName,
        email,
        company,
        productName: selectedProduct,
        productCode,
        productPrice: Number(productPrice),
        finalAmount: finalAmount,
        paymentType,

        advancePayment:
          paymentType === "installment" || paymentType === "advance"
            ? Number(advancePayment)
            : 0,

        installmentMonths:
          paymentType === "installment"
            ? Number(installmentMonths)
            : 0,

        eachInstallment:
          paymentType === "installment"
            ? Number(eachInstallment)
            : 0,

        remark,
        quantitySold: sellQty,
        createdAt: serverTimestamp(),
      });

      // stock history
      const historyRef = doc(collection(db, "stock_history"));

      transaction.set(historyRef, {
        productName: selectedProduct,
        productCode,
        quantityChanged: sellQty,
        type: "OUT",
        customerName,
        company,
        createdAt: serverTimestamp(),
      });
    });

    alert("✅ Invoice created successfully");
    generateInvoicePDF();

    setSellQuantity(1);

  } catch (error) {
    console.error(error);
    alert(error.message);
  }
};



const generateInvoicePDF = () => {
  const doc = new jsPDF();

  // ✅ ========== BACKGROUND WATERMARK ==========
  const watermarkLogo = `${process.env.PUBLIC_URL}/optica-no-bg.png`;
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const logoWidth = 160;
  const logoHeight = 80;
  const x = (pageWidth - logoWidth) / 2;
  const y = (pageHeight - logoHeight) / 2;

  doc.setGState(new doc.GState({ opacity: 0.1 }));
  doc.addImage(watermarkLogo, "JPEG", x, y, logoWidth, logoHeight, "", "SLOW");
  doc.setGState(new doc.GState({ opacity: 1 }));

  // ✅ ========== HEADER BACKGROUND ==========
  const headerHeight = 40;
  doc.setFillColor(255, 255, 255); // 🔵 Dodger Blue
  doc.rect(0, 0, pageWidth, headerHeight, "F");

  // ✅ Logo at left of header
  const logo = `${process.env.PUBLIC_URL}/optica-no-bg.png`;
  doc.addImage(logo, "PNG", 10, 5, 60, 25); // left side

  // ✅ Company name & info in table format
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(16);
  doc.text("OPTICA INTERNATIONAL (PVT) LTD", 70, 15);

  doc.setFontSize(9);
  doc.text("932, Maradana Road, Colombo 08", 70, 23);
  doc.text(" 011 268 2277 / 076 136 0946 / 077 344 0937 | opticainternational2026@gmail.com", 70, 29);

  // ✅ ========== FOOTER BACKGROUND ==========
  const footerHeight = 20;
  doc.setFillColor(0, 0, 0);
  doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(10);
  doc.text("Thank you for your purchase!", pageWidth / 2, pageHeight - 8, { align: "center" });

  // ✅ ========== INVOICE DETAILS ==========
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(12);
  let contentY = headerHeight + 15;

  doc.text(`Invoice No: ${invoiceNumber}`, 14, contentY);
  doc.text(`Date: ${date}`, pageWidth - 60, contentY);
  contentY += 10;
  doc.text(`Customer: ${customerName}`, 14, contentY);
  contentY += 8;
  doc.text(`Email: ${email}`, 14, contentY);
  contentY += 8;
  doc.text(`Company: ${company}`, 14, contentY);

  // ✅ ========== PRODUCT TABLE ==========
 const tableColumn = ["Product Name", "Code", "Unit Price (Rs.)", "Qty", "Total (Rs.)"];
const tableRows = [
 [
   selectedProduct || "-",
   productCode || "-",
   Number(productPrice || 0).toFixed(2),
   Number(sellQuantity || 0),
   Number(finalAmount || 0).toFixed(2),
 ],
];



  autoTable(doc, {
    startY: contentY + 10,
    head: [tableColumn],
    body: tableRows,
    styles: { halign: "center" },
    headStyles: { fillColor: [0, 0, 0], textColor: 255 },
  });

  let finalY = doc.lastAutoTable.finalY + 30;

  // ✅ ========== PAYMENT DETAILS ==========
doc.text(`Total Amount: ${finalAmount}`, 140, finalY);

if (paymentType === "advance") {
  doc.text(`Advance Payment: Rs.${advancePayment}`, 140, finalY + 8);
   doc.text(`Balance Payment: Rs.${ finalAmount-advancePayment}`, 140, finalY + 16);
    finalY += 15;
}




if (paymentType === "installment") {
  doc.text(`Advance Payment: Rs.${advancePayment}`, 140, finalY + 8);
  doc.text(`Installment Months: ${installmentMonths}`, 140, finalY + 16);
  doc.text(`Each Installment: Rs.${eachInstallment}`, 140, finalY + 24);
  finalY += 30;
}


  if (remark) {
    doc.text(`Remark: ${remark}`, 14, finalY + 10);
  }

  // ✅ ========== SAVE ==========
  doc.save(`Invoice_${invoiceNumber}.pdf`);
};








///////////////////////////////////////////////// view purchased products /////////////////////////////////////////////////`

  // --- States ---
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterCompany, setFilterCompany] = useState("");
  const [filterMinPrice, setFilterMinPrice] = useState("");
  const [filterMaxPrice, setFilterMaxPrice] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editedData, setEditedData] = useState({
    customerName: "",
    email: "",
    company: "",
    productPrice: "",
    paymentType: "",
    remark: ""
  });

  // --- Fetch All Products ---
  // const fetchAllProducts = async () => {
  //   try {
  //     const q = query(collection(db, "purchased_products"));
  //     const snapshot = await getDocs(q);
  //     const fetched = snapshot.docs.map((doc) => ({
  //       id: doc.id,
  //       ...doc.data(),
  //     }));
  //     setProducts(fetched);
  //     setFilteredProducts(fetched);
  //   } catch (error) {
  //     console.error("Error fetching products:", error);
  //   }
  // };
const fetchAllProducts = async () => {
  try {
    const q = query(collection(db, "purchased_products"));

    const snapshot = await getDocs(q);

    let fetched = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // ✅ Latest invoice numbers first
    fetched.sort((a, b) => {
      const aNum = Number(
        String(a.invoiceNumber || "0").replace(/\D/g, "")
      );

      const bNum = Number(
        String(b.invoiceNumber || "0").replace(/\D/g, "")
      );

      return bNum - aNum;
    });

    setProducts(fetched);
    setFilteredProducts(fetched);

  } catch (error) {
    console.error("Error fetching products:", error);
  }
};







  useEffect(() => {
    fetchAllProducts();
  }, []);

  // --- Filter ---
  const fetchFilteredProducts = () => {
    let filtered = products;

    if (filterName.trim()) {
      filtered = filtered.filter((p) =>
        p.customerName?.toLowerCase().includes(filterName.toLowerCase())
      );
    }

    if (filterCompany.trim()) {
      filtered = filtered.filter((p) =>
        p.company?.toLowerCase().includes(filterCompany.toLowerCase())
      );
    }

    if (filterMinPrice || filterMaxPrice) {
      filtered = filtered.filter((p) => {
        const price = Number(p.productPrice) || 0;
        const min = Number(filterMinPrice) || 0;
        const max = Number(filterMaxPrice) || Infinity;
        return price >= min && price <= max;
      });
    }

    setFilteredProducts(filtered);
  };

  // --- Edit ---
  const handleEdit = (product) => {
    setEditingProduct(product);
    setEditedData({
      customerName: product.customerName || "",
      email: product.email || "",
      company: product.company || "",
      productPrice: product.productPrice || "",
      paymentType: product.paymentType || "",
      remark: product.remark || "",
    });
    setShowEditModal(true);
  };

  const handleEditChangeProduct = (e) => {
    const { name, value } = e.target;
    setEditedData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveEdit = async () => {
    try {
      await updateDoc(doc(db, "purchased_products", editingProduct.id), editedData);
      alert("✅ Product updated successfully!");
      setShowEditModal(false);
      fetchAllProducts();
    } catch (error) {
      console.error("Error updating product:", error);
      alert("❌ Failed to update product.");
    }
  };

  // --- Delete ---
  const handleDelete = async (product) => {
    if (window.confirm(`Are you sure you want to delete "${product.customerName}"?`)) {
      try {
        await deleteDoc(doc(db, "purchased_products", product.id));
        alert("🗑 Product deleted successfully");
        fetchAllProducts();
      } catch (error) {
        console.error("Error deleting product:", error);
        alert("❌ Failed to delete product.");
      }
    }
  };

 
// --- PDF Download ---
const handleDownload = (product) => {
  const doc = new jsPDF("p", "mm", "a4");

  const {
    productName,
    selectedProduct,
    productCode,
    productPrice,
    quantitySold,
    finalAmount,
    invoiceNumber,
    date,
    customerName,
    email,
    company,
    paymentType,
    advancePayment,
    installmentMonths,
    eachInstallment,
    remark,
  } = product;

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // =====================================
  // WATERMARK
  // =====================================
  const watermarkLogo = `${process.env.PUBLIC_URL}/optica-no-bg.png`;

  try {
    doc.setGState(new doc.GState({ opacity: 0.08 }));
    doc.addImage(
      watermarkLogo,
      "JPEG",
      pageWidth / 2 - 55,
      pageHeight / 2 - 30,
      110,
      60
    );
    doc.setGState(new doc.GState({ opacity: 1 }));
  } catch (err) {}

  // =====================================
  // HEADER
  // =====================================
  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, pageWidth, 38, "F");

  try {
    const logo = `${process.env.PUBLIC_URL}/optica-no-bg.png`;
    doc.addImage(logo, "JPEG", 10, 5, 60, 25);
  } catch (err) {}

  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("OPTICA INTERNATIONAL (PVT) LTD", 75, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("932, Maradana Road, Colombo 08", 75, 22);
  doc.text("011 268 2277 / 076 136 0946 / 077 344 0937 | opticainternational2026@gmail.com", 75, 28);

  // =====================================
  // FOOTER
  // =====================================
  doc.setFillColor(0, 0, 0);
  doc.rect(0, pageHeight - 18, pageWidth, 18, "F");

  doc.setFontSize(10);
  doc.setTextColor(255, 255, 255);
  doc.text("Thank you for your purchase!", pageWidth / 2, pageHeight - 7, {
    align: "center",
  });

  // =====================================
  // TITLE
  // =====================================
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("INVOICE", pageWidth / 2, 50, { align: "center" });

  // =====================================
  // CUSTOMER DETAILS
  // =====================================
  let y = 62;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);

  doc.text(`Invoice No : ${invoiceNumber || "-"}`, 14, y);
  doc.text(`Date : ${date || "-"}`, 145, y);

  y += 8;
  doc.text(`Customer : ${customerName || "-"}`, 14, y);

  y += 8;
  doc.text(`Email : ${email || "-"}`, 14, y);

  y += 8;
  doc.text(`Company : ${company || "-"}`, 14, y);

  // =====================================
  // PRODUCT TABLE
  // =====================================
  const tableColumn = [
    "Product Name",
    "Code",
    "Unit Price",
    "Qty",
    "Total",
  ];

  const tableRows = [
    [
      productName || selectedProduct || "-",
      productCode || "-",
      Number(productPrice || 0).toFixed(2),
      Number(quantitySold || 0),
      Number(finalAmount || 0).toFixed(2),
    ],
  ];

  autoTable(doc, {
    startY: y + 10,
    head: [tableColumn],
    body: tableRows,
    theme: "grid",

    styles: {
      halign: "center",
      fontSize: 10,
    },

    headStyles: {
      fillColor: [0, 0, 0],
      textColor: 255,
      fontStyle: "bold",
    },
  });

  let finalY = doc.lastAutoTable.finalY + 12;

  // =====================================
  // PAYMENT DETAILS
  // =====================================
  doc.setFont("helvetica", "bold");
  doc.text(
    `Grand Total : Rs. ${Number(finalAmount || 0).toFixed(2)}`,
    130,
    finalY
  );

  doc.setFont("helvetica", "normal");

  if (paymentType === "advance") {
    finalY += 8;

    doc.text(
      `Advance Payment : Rs. ${Number(advancePayment || 0).toFixed(2)}`,
      130,
      finalY
    );

    finalY += 8;

    doc.text(
      `Balance : Rs. ${(
        Number(finalAmount || 0) - Number(advancePayment || 0)
      ).toFixed(2)}`,
      130,
      finalY
    );
  }

  if (paymentType === "installment") {
    finalY += 8;

    doc.text(
      `Advance Payment : Rs. ${Number(advancePayment || 0).toFixed(2)}`,
      130,
      finalY
    );

    finalY += 8;
    doc.text(`Installment Months : ${installmentMonths || 0}`, 130, finalY);

    finalY += 8;

    doc.text(
      `Each Installment : Rs. ${Number(eachInstallment || 0).toFixed(2)}`,
      130,
      finalY
    );
  }

  // if (paymentType === "full") {
  //   finalY += 8;
  //   doc.text("Payment Status : Fully Paid", 130, finalY);
  // }

  // =====================================
  // REMARK
  // =====================================
  if (remark) {
    finalY += 15;

    doc.setFont("helvetica", "bold");
    doc.text("Remark :", 14, finalY);

    doc.setFont("helvetica", "normal");

    const splitText = doc.splitTextToSize(remark, 180);
    doc.text(splitText, 14, finalY + 7);
  }

  // =====================================
  // SAVE
  // =====================================
  doc.save(`Invoice_${invoiceNumber || "NoNumber"}.pdf`);
};









const handlePurchasedProductDelete = async (product) => {
  if (!product?.id) {
    alert("❌ Product ID not found!");
    return;
  }

  const confirmDelete = window.confirm(`Are you sure you want to delete "${product.customerName}"?`);
  if (!confirmDelete) return;

  try {
    console.log("Attempting to delete product ID:", product.id);
    await deleteDoc(doc(db, "purchased_products", product.id));
    alert("✅ Product deleted successfully!");
    fetchAllProducts(); // refresh table
  } catch (error) {
    console.error("❌ Error deleting product:", error);
    alert("Failed to delete product. Check console for details.");
  }
};




///////////////////////////////////// add new product ///////////////////////////////////////

  const [formData, setFormData] = useState({
    productName: "",
    productCode: "",
    buyingPrice: "",
    sellingPrice: "",
    supplier: "",
    quantity: "",
    sold: "",
    remark: "",
  });






  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (
      !formData.productName ||
      !formData.productCode ||
      !formData.buyingPrice ||
      !formData.sellingPrice ||
      !formData.supplier,
      !formData.quantity

    ) {
      setMessage("⚠️ Please fill all required fields.");
      return;
    }

    setLoading(true);
    try {
      await addDoc(collection(db, "new_products"), {
        ...formData,
        buyingPrice: Number(formData.buyingPrice),
        sellingPrice: Number(formData.sellingPrice),
        createdAt: serverTimestamp(),
      });
      setMessage("✅ Product added successfully!");
      setFormData({
        productName: "",
        productCode: "",
        buyingPrice: "",
        sellingPrice: "",
        supplier: "",
        quantity: "",
        remark: "",
      });
    } catch (error) {
      console.error("Error adding product:", error);
      setMessage("❌ Failed to add product. Try again.");
    } finally {
      setLoading(false);
    }
  };




//////////////////////////////////////////// view all products ////////////////////////////////////////////////////////////////

  //fetch all the product that has entered  
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});

  // Fetch all products from Firestore
const fetchProducts = async () => {
  try {
    setLoading(true);

    // Query products ordered by createdAt descending
    const q = query(collection(db, "new_products"), orderBy("createdAt", "desc"));
    const querySnapshot = await getDocs(q);

    const data = querySnapshot.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }));

    console.log("Fetched products:", data); // ✅ Debug log
    setProducts(data);
  } catch (error) {
    console.error("Error fetching products:", error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchProducts();
  }, []);

  // Handle delete
  const handleProductDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this product?");
    if (confirmDelete) {
      await deleteDoc(doc(db, "new_products", id));
      setProducts(products.filter((p) => p.id !== id));
    }
  };

  // Handle edit start
  const handleProductEdit = (product) => {
    setEditingId(product.id);
    setEditData({ ...product });
  };

  // Handle edit change
  const handleProductEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle save edit
  const handleSave = async (id) => {
    const productRef = doc(db, "new_products", id);
    await updateDoc(productRef, {
      productName: editData.productName,
      productCode: editData.productCode,
      buyingPrice: Number(editData.buyingPrice),
      sellingPrice: Number(editData.sellingPrice),
      supplier: editData.supplier,
      remark: editData.remark,
    });

    setProducts((prev) =>
      prev.map((p) => (p.id === id ? { ...editData, id } : p))
    );
    setEditingId(null);
  };

  // Handle cancel edit
  const handleCancel = () => {
    setEditingId(null);
    setEditData({});
  };




  ////////// group stock 
  const groupedStock = products.reduce((acc, item) => {
  const code = item.productCode;

  const qty = Number(item.quantity) || 0;

  if (!acc[code]) {
    acc[code] = {
      productCode: code,
      totalStock: 0,
      productName: item.productName,
    };
  }

  acc[code].totalStock += qty;

  return acc;
}, {});

const stockSummary = Object.values(groupedStock);



/////////// Update Customer Payment  //////////////////////////// update payment   details //////////////////////////////////////////

// === State ===
const [paymentData, setPaymentData] = useState({
  paymentDate: "",
  installmentAmount: "",
});




const fetchAllPurchases = async () => {
  setLoading(true);

  try {
    const snapshot = await getDocs(
      collection(db, "purchased_products")
    );

    let data = snapshot.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }));

    // ✅ Latest invoice first
    data.sort((a, b) => {
      const aNum = Number(
        String(a.invoiceNumber || "").replace(/\D/g, "")
      );

      const bNum = Number(
        String(b.invoiceNumber || "").replace(/\D/g, "")
      );

      return bNum - aNum;
    });

    setPurchasedItems(data);
    setFilteredPurchases(data);

  } catch (error) {
    console.error("Error fetching purchases:", error);
    alert("Failed to fetch purchases");
  } finally {
    setLoading(false);
  }
};






useEffect(() => {
  fetchAllPurchases();
}, []);

// === Filter Purchases ===
const fetchFilteredPurchases = () => {
  let filtered = [...purchasedItems];
  if (filterName)
    filtered = filtered.filter((p) =>
      p.customerName?.toLowerCase().includes(filterName.toLowerCase())
    );
  if (filterCompany)
    filtered = filtered.filter((p) =>
      p.company?.toLowerCase().includes(filterCompany.toLowerCase())
    );
  if (filterEmail)
    filtered = filtered.filter((p) =>
      p.email?.toLowerCase().includes(filterEmail.toLowerCase())
    );
  setFilteredPurchases(filtered);
};






// === Select Purchase ===
const handleSelectPurchase = (purchase) => {
  setSelectedPurchase(purchase);
  setPaymentData({ paymentDate: "", installmentAmount: "" });
};




const handleSavePayment = async (purchaseId) => {
  if (!paymentData.paymentDate || !paymentData.installmentAmount) {
    alert("Please enter both date and installment amount.");
    return;
  }

  const paymentValue = Number(paymentData.installmentAmount);
  const paymentRef = collection(db, "payments");
  const purchaseRef = doc(db, "purchased_products", purchaseId);

  try {
    // Calculate new totals
    const previousInstallmentsPaidAmount = selectedPurchase.installmentsPaidAmount || 0;
    const previousInstallmentsCount = selectedPurchase.installmentsPaid || 0;
    const totalPaidBefore = (selectedPurchase.advancePayment || 0) + previousInstallmentsPaidAmount;
    const outstandingAmount = (selectedPurchase.finalAmount || 0) - totalPaidBefore;

    // If the entered payment exceeds outstanding, cap it
    const actualPayment = Math.min(paymentValue, outstandingAmount);


    //newly added code for sub invoice
    const installmentNumber = previousInstallmentsCount + 1;

const subInvoiceNumber =
  selectedPurchase.paymentType === "installment"
    ? `${selectedPurchase.invoiceNumber}-${installmentNumber}`
    : selectedPurchase.invoiceNumber;



    // 1️⃣ Add payment to 'payments' collection
    // await addDoc(paymentRef, {
    //   purchaseId,
    //   customerName: selectedPurchase.customerName,
    //   company: selectedPurchase.company,
    //   email: selectedPurchase.email,
    //   productCode: selectedPurchase.productCode,
    //   productName: selectedPurchase.productName,
    //   paymentDate: paymentData.paymentDate,
    //   installmentAmount: actualPayment,
    //   createdAt: serverTimestamp(),
    // });

await addDoc(paymentRef, {
  purchaseId,

  // ✅ Main Invoice
  mainInvoiceNumber: selectedPurchase.invoiceNumber,

  // ✅ Sub Invoice
  subInvoiceNumber,

  customerName: selectedPurchase.customerName,
  company: selectedPurchase.company,
  email: selectedPurchase.email,

  productCode: selectedPurchase.productCode,
  productName: selectedPurchase.productName,

  paymentDate: paymentData.paymentDate,
  installmentAmount: actualPayment,

  paymentType: selectedPurchase.paymentType,

  installmentNumber:
    selectedPurchase.paymentType === "installment"
      ? installmentNumber
      : null,

  createdAt: serverTimestamp(),
});







    // 2️⃣ Update purchase totals
    const isInstallment = selectedPurchase.paymentType === "installment";

    await updateDoc(purchaseRef, {
      installmentsPaid: isInstallment ? previousInstallmentsCount + 1 : previousInstallmentsCount,
      installmentsPaidAmount: previousInstallmentsPaidAmount + actualPayment,
      lastUpdated: serverTimestamp(),
    });

    // 3️⃣ Generate slip
    generateSinglePaymentSlip({
      mainInvoiceNumber: selectedPurchase.invoiceNumber,
      subInvoiceNumber,
      customerName: selectedPurchase.customerName,
      company: selectedPurchase.company,
      email: selectedPurchase.email,
      productCode: selectedPurchase.productCode,
      productName: selectedPurchase.productName,
      paymentDate: paymentData.paymentDate,
      installmentAmount: actualPayment,
      noOfInstallments: selectedPurchase.installmentMonths || "-",
      eachInstallment: selectedPurchase.eachInstallment || "-",
      advancePayment: selectedPurchase.advancePayment || 0,
      productPrice: selectedPurchase.productPrice || 0,
      installmentsPaidAmount: previousInstallmentsPaidAmount + actualPayment,
    });

alert("Payment updated successfully!");

// 🔥 Reload updated purchase data from Firestore
await fetchAllPurchases();

setSelectedPurchase(null);
setPaymentData({ paymentDate: "", installmentAmount: "" });
  } catch (error) {
    console.error("Error updating payment:", error);
    alert("Failed to update payment.");
  }
};


const generateSinglePaymentSlip = (details) => {
  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Watermark
  const watermarkLogo = `${process.env.PUBLIC_URL}/optica-no-bg.png`;
  try {
    doc.setGState(new doc.GState({ opacity: 0.08 }));
    doc.addImage(watermarkLogo, "PNG", (pageWidth - 140) / 2, (pageHeight - 100) / 2, 160, 100);
    doc.setGState(new doc.GState({ opacity: 1 }));
  } catch {}

  // Header
  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, pageWidth, 40, "F");
  try { doc.addImage(`${process.env.PUBLIC_URL}/optica-no-bg.png`, "JPEG", 10, 5, 30, 30); } catch {}
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(16);
  doc.text("OPTICA INTERNATIONAL", 50, 15);
  doc.setFontSize(10);
  doc.text("932, Maradana Road, Colombo 08", 50, 23);
  doc.text("Tel: 011 268 2277 / 077 344 0937", 50, 29);
  doc.text("Email: opticainternational@gmail.com", 50, 35);

  // Title
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(14);
  doc.text("Payment Slip", pageWidth / 2, 55, { align: "center" });
  doc.setFontSize(11);
  doc.text(`Date: ${details.paymentDate || "-"}`, 20, 65);
  doc.text(`Sub Invoice No: ${details.subInvoiceNumber || "-"}`, 20, 73);

  // Customer Info
  let yPos = 80;
  const lineGap = 8;
  doc.text(`Customer Name: ${details.customerName || "-"}`, 20, yPos);
  yPos += lineGap;
  doc.text(`Company: ${details.company || "-"}`, 20, yPos);
  yPos += lineGap;
  doc.text(`Email: ${details.email || "-"}`, 20, yPos);

  // Product Details Header
  yPos += 15;
  doc.setFillColor(230, 240, 255);
  doc.rect(20, yPos, pageWidth - 40, 10, "F");
  doc.text("Product Code", 25, yPos + 7);
  doc.text("Product Name", 80, yPos + 7);


  const isInstallment = details.noOfInstallments && details.noOfInstallments !== "-";
  const paymentLabel = isInstallment ? "Installment (Rs.)" : "Settlement Amount (Rs.)";
  doc.text(paymentLabel, 150, yPos + 7);

  // Product Data
  yPos += 18;
  doc.text(details.productCode || "-", 25, yPos);
  doc.text(details.productName || "-", 80, yPos);


  doc.text(`Rs.${details.installmentAmount.toLocaleString()}`, 150, yPos);

  // Payment Summary
  yPos += 20;
  const totalInstallmentsPaid = details.installmentsPaidAmount || 0;
  const totalPaid = (details.advancePayment || 0) + totalInstallmentsPaid;
  const outstanding = Math.max((details.finalAmount || 0) - totalPaid, 0);

  if (yPos > pageHeight - 40) { doc.addPage(); yPos = 20; }

  doc.setFontSize(11);
  doc.text(`Advance Payment: Rs.${(details.advancePayment || 0).toLocaleString()}`, 20, yPos);
  yPos += 8;

  if (isInstallment) {
    doc.text(`Installments Paid: Rs.${totalInstallmentsPaid.toLocaleString()}`, 20, yPos);
    yPos += 8;
  } else {
    // Settlement payment
    doc.text(`Settlement Paid: Rs.${details.installmentAmount.toLocaleString()}`, 20, yPos);
    yPos += 8;
  }
  doc.text(`Total Amount: Rs.${finalAmount.toLocaleString()}`, 20, yPos);
  yPos += 8;

  doc.text(`Total Amount Paid: Rs.${totalPaid.toLocaleString()}`, 20, yPos);
  yPos += 8;
  doc.text(`Outstanding Balance: Rs.${outstanding.toLocaleString()}`, 20, yPos);

  // Footer
  doc.setFillColor(30, 144, 255);
  doc.rect(0, pageHeight - 20, pageWidth, 20, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(10);
  doc.text("Thank you for your payment!", pageWidth / 2, pageHeight - 8, { align: "center" });

  // Save PDF
  const fileName = `PaymentSlip_${details.customerName || "Customer"}_${Date.now()}.pdf`;
  doc.save(fileName);
};








const downloadPaymentReport = () => {
  let filteredData = [...purchasedItems];

  // Filter by exact date
  if (reportDate) {
    filteredData = filteredData.filter(
      (item) => item.purchaseDate === reportDate
    );
  }

  // Filter by month + year
  else if (reportMonth && reportYear) {
    filteredData = filteredData.filter((item) => {
      if (!item.purchaseDate) return false;

      const date = new Date(item.purchaseDate);

      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear());

      return month === reportMonth && year === reportYear;
    });
  }

  if (filteredData.length === 0) {
    alert("No records found for selected filters.");
    return;
  }

  // Format data for Excel
  // const excelData = filteredData.map((purchase, index) => {
  //   const totalInstallmentsPaid =
  //     purchase.installmentsPaidAmount || 0;

  //   const totalPaid =
  //     (purchase.advancePayment || 0) + totalInstallmentsPaid;

  //   const outstanding = Math.max(
  //     (purchase.finalAmount || 0) - totalPaid,
  //     0
  //   );

  //   return {
      
  //     "Main Invoice No": purchase.invoiceNumber || "-",
  //     "Customer Name": purchase.customerName || "-",
  //     "Company": purchase.company || "-",
  //     "Email": purchase.email || "-",
  //     "Product Code": purchase.productCode || "-",
  //     "Product Name": purchase.productName || "-",
  //     "Quantity": purchase.quantitySold || 0,
  //     "Payment Type": purchase.paymentType || "-",
  //     "Advance Payment": purchase.advancePayment || 0,
  //     "Installments Paid": purchase.installmentsPaid || 0,
  //     "Installments Amount":
  //       purchase.installmentsPaidAmount || 0,
  //     "Total Amount": purchase.finalAmount || 0,
  //     "Total Paid": totalPaid,
  //     "Outstanding Balance": outstanding,
  //     "Purchase Date": purchase.date || "-",
  //   };
  // });

  // // Create worksheet
  // const worksheet = XLSX.utils.json_to_sheet(excelData);

  const excelData = filteredData.map((purchase, index) => {
  const totalInstallmentsPaid =
    purchase.installmentsPaidAmount || 0;

  const totalPaid =
    (purchase.advancePayment || 0) + totalInstallmentsPaid;

  const outstanding = Math.max(
    (purchase.finalAmount || 0) - totalPaid,
    0
  );

  return {
    "Main Invoice No": purchase.invoiceNumber || "-",
    "Customer Name": purchase.customerName || "-",
    "Company": purchase.company || "-",
    "Email": purchase.email || "-",
    "Product Code": purchase.productCode || "-",
    "Product Name": purchase.productName || "-",
    "Quantity": purchase.quantitySold || 0,
    "Payment Type": purchase.paymentType || "-",
    "Advance Payment": purchase.advancePayment || 0,

    "Advance Paid Date": purchase.advancePayment > 0 ? purchase.date || "-" : "-",

    "Installments Paid": purchase.installmentsPaid || 0,
    "Installments Amount": purchase.installmentsPaidAmount || 0,
    "Total Amount": purchase.finalAmount || 0,
    "Total Paid": totalPaid,
    "Outstanding Balance": outstanding,
    "Purchase Date": purchase.date || "-",
  };
});

 // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(excelData);




  // Auto width
  const columnWidths = Object.keys(excelData[0]).map((key) => ({
    wch: key.length + 10,
  }));

  worksheet["!cols"] = columnWidths;

  // Create workbook
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Payment Report"
  );

  // Generate Excel file
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const fileData = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  let fileName = "Payment_Report.xlsx";

  if (reportDate) {
    fileName = `Payment_Report_${reportDate}.xlsx`;
  } else if (reportMonth && reportYear) {
    fileName = `Payment_Report_${reportMonth}_${reportYear}.xlsx`;
  }

  saveAs(fileData, fileName);
};




///////////////////////////////////// download all payments in Update Customer Payment /////////////////////////////////////////////////

// const downloadAllPayments = async (purchase) => {
//   const paymentsQuery = query(
//     collection(db, "payments"),
//     where("purchaseId", "==", purchase.id)
//   );
//   const snapshot = await getDocs(paymentsQuery);
//   const payments = snapshot.docs.map((d) => d.data());

//   const doc = new jsPDF("p", "mm", "a4");
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();

//   // 🩵 === Watermark ===
//   const watermarkLogo = `${process.env.PUBLIC_URL}/logo-optica.jpg`;
//   const logoWidth = 140;
//   const logoHeight = 80;
//   const x = (pageWidth - logoWidth) / 2;
//   const y = (pageHeight - logoHeight) / 2;

//   try {
//     doc.setGState(new doc.GState({ opacity: 0.08 }));
//     doc.addImage(watermarkLogo, "JPEG", x, y, logoWidth, logoHeight, "", "SLOW");
//     doc.setGState(new doc.GState({ opacity: 1 }));
//   } catch (err) {
//     console.warn("Watermark not found:", err);
//   }

//   // 🩶 === Header ===
//   const headerHeight = 40;
//   doc.setFillColor(30, 144, 255);
//   doc.rect(0, 0, pageWidth, headerHeight, "F");

//   const logo = `${process.env.PUBLIC_URL}/logo-optica.jpg`;
//   try {
//     doc.addImage(logo, "JPEG", 10, 5, 30, 30);
//   } catch (error) {
//     console.warn("Logo not found, continuing without logo");
//   }

//   doc.setTextColor(255, 255, 255);
//   doc.setFontSize(16);
//   doc.text("OPTICA INTERNATIONAL", 50, 15);
//   doc.setFontSize(9);
//   doc.text("932, Maradana Road, Colombo 08", 50, 23);
//   doc.text("011 268 2277 / 077 344 0937", 50, 29);
//   doc.text("opticainternational@gmail.com", 50, 35);

 


// // 🧾 === Customer & Purchase Details ===
// doc.setFontSize(10);
// doc.setTextColor(0, 0, 0);

// let yPos = 55;
// const labelX = 20;
// const valueX = 80;
// const lineHeight = 8;

// // Section Title Helper
// const drawSection = (title) => {
//   doc.setFont(undefined, "bold");
//   doc.setFontSize(9);
//   doc.text(title, labelX, yPos);

//   yPos += 6;

//   // Divider line
//   doc.setLineWidth(0.3);
//   doc.line(labelX, yPos, 190, yPos);

//   yPos += 6;

//   doc.setFontSize(8);
// };

// // Row Helper
// const drawRow = (label, value) => {
//   doc.setFont(undefined, "bold");
//   doc.text(label, labelX, yPos);

//   doc.setFont(undefined, "normal");
//   doc.text(value, valueX, yPos);

//   yPos += lineHeight;
// };



// // // 🔹 Customer Information
// drawSection("Customer Information");

// drawRow("Customer Name:", purchase.customerName || "-");
// drawRow("Company:", purchase.company || "-");
// drawRow("Email:", purchase.email || "-");

// yPos += 2;


// // // 🔹 Product Details
// drawSection("Product Details");
// drawRow("Main Invoice No:", purchase.invoiceNumber || "-");
// drawRow("Product Name:", purchase.productName || "-");
// drawRow("Product Code:", purchase.productCode || "-");
// drawRow("Product Price:", `Rs. ${purchase.productPrice || "-"}`);

// yPos += 2;


// // // 🔹 Payment Details
// drawSection("Payment Details");

// drawRow("Advance Payment:", `Rs. ${purchase.advancePayment || 0}`);
// drawRow("Installments Paid:", `${purchase.installmentsPaid || 0}`);
// drawRow("No. of Installments:", `${purchase.installmentMonths || "-"}`);
// drawRow("Each Installment:", `Rs. ${purchase.eachInstallment || "-"}`);

// yPos += 5;



//   // 🧮 === Table Header ===
//   const col1X = 20;
//   const col2X = 60;
//   const col3X = 130;

//   const rowHeight = 10;
//   const tableWidth = pageWidth - 40;
//   const col1Width = 40;
//   const col2Width = 70;
//   const col3Width = 60;

//   // Draw header background
//   doc.setFillColor(30, 144, 255);
//   doc.rect(col1X, yPos, tableWidth, rowHeight, "F");

//   // Header text
//   doc.setTextColor(255, 255, 255);
//   doc.setFontSize(9);
  
//   doc.text("Sub Invoice Number", col1X + 5, yPos + 7);
//   doc.text("Payment Date", col2X + 5, yPos + 7);
//   doc.text("Installment Amount (Rs.)", col3X + 5, yPos + 7);

//   yPos += rowHeight;
//   doc.setTextColor(0, 0, 0);

//   // 🧾 === Table Rows ===
//   payments.forEach((p, index) => {
//     // Draw row border
//     doc.rect(col1X, yPos, col1Width, rowHeight);
//     doc.rect(col1X + col1Width, yPos, col2Width, rowHeight);
//     doc.rect(col1X + col1Width + col2Width, yPos, col3Width, rowHeight);

//     // Add text
//     doc.text(p.subInvoiceNumber || "-", col1X + 5, yPos + 7);
//     doc.text(p.paymentDate || "-", col2X + 5, yPos + 7);
//     doc.text(`Rs.${p.installmentAmount || "-"}`, col3X + 5, yPos + 7);

//     yPos += rowHeight;

//     // Add new page if near bottom
//     if (yPos > pageHeight - 40) {
//       doc.addPage();
//       yPos = 20;
//     }
//   });





// // === Financial Summary Section ===

// // 🔢 Calculations
// const totalPaid = payments.reduce(
//   (sum, p) => sum + (Number(p.installmentAmount) || 0),
//   0
// );

// const advance = Number(purchase.advancePayment) || 0;
// const finalAmount = Number(purchase.finalAmount || purchase.productPrice) || 0;

// const totalAmountPaid = advance + totalPaid;
// const balance = finalAmount - totalAmountPaid;

// // 💰 Currency formatter (consistent everywhere)
// const formatCurrency = (val) => `Rs. ${Number(val || 0).toLocaleString()}`;

// // 📏 Layout safety (prevent footer overlap)
// const footerHeight = 14;
// const safeBottom = pageHeight - footerHeight - 10;

// if (yPos > safeBottom) {
//   doc.addPage();
//   yPos = 20;
// }

// // 📍 Positions (renamed to avoid conflict)
// yPos += 10;

// const summaryLabelX = 20;
// const summaryValueX = 150;
// const summaryLineHeight = 8;

// // 🔹 Section Header
// doc.setFontSize(8);
// // doc.setFont(undefined, "bold");
// // doc.text("Financial Summary", summaryLabelX, yPos);

// yPos += 3;

// // // Divider
// // doc.setLineWidth(0.3);
// // doc.line(summaryLabelX, yPos, 190, yPos);

// yPos += 5;

// // 🔹 Row helper
// const drawSummaryRow = (label, value, isBold = false) => {
//   doc.setFont(undefined, isBold ? "bold" : "normal");
//   doc.setFontSize(8);

//   doc.text(label, summaryLabelX, yPos);
//   doc.text(value, summaryValueX, yPos, { align: "right" });

//   yPos += summaryLineHeight;
// };

// // 🔹 Rows
// drawSummaryRow("Advance Payment:", formatCurrency(advance));
// drawSummaryRow("Installments Paid:", formatCurrency(totalPaid));
// drawSummaryRow("Total Paid:", formatCurrency(totalAmountPaid));

// // // Divider before balance
// // yPos += 2;
// // doc.line(summaryLabelX, yPos, 190, yPos);
// // yPos += 6;

// // 🔥 Balance highlight (with color logic)
// doc.setFontSize(8);

// if (balance > 0) {
//   doc.setTextColor(200, 0, 0); // red = due
// } else {
//   doc.setTextColor(0, 150, 0); // green = paid
// }

// drawSummaryRow("Balance Amount:", formatCurrency(balance), true);

// // Reset color
// doc.setTextColor(0, 0, 0);

// yPos += 10;







//   // 💙 === Footer ===
//   // const footerHeight = 20;
//   doc.setFillColor(30, 144, 255);
//   doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");
//   doc.setTextColor(255, 255, 255);
//   doc.setFontSize(9);
//   doc.text("Thank you for your payment!", pageWidth / 2, pageHeight - 8, { align: "center" });

//   // 💾 === Save PDF ===
//   doc.save(`AllPayments_${purchase.customerName}_${Date.now()}.pdf`);
// };


const downloadAllPayments = async (purchase) => {
  const paymentsQuery = query(
    collection(db, "payments"),
    where("purchaseId", "==", purchase.id)
  );

  const snapshot = await getDocs(paymentsQuery);

  // ✅ SORT PAYMENTS BY OLDEST DATE FIRST (ASCENDING)
  const payments = snapshot.docs
    .map((d) => d.data())
    .sort((a, b) => {
      const dateA = a.paymentDate?.toDate
        ? a.paymentDate.toDate()
        : new Date(a.paymentDate);

      const dateB = b.paymentDate?.toDate
        ? b.paymentDate.toDate()
        : new Date(b.paymentDate);

      return dateA - dateB; // Oldest first
    });

  const doc = new jsPDF("p", "mm", "a4");

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // 🩵 Watermark
  const watermarkLogo = `${process.env.PUBLIC_URL}/optica-no-bg.png`;

  try {
    doc.setGState(new doc.GState({ opacity: 0.08 }));

    doc.addImage(
      watermarkLogo,
      "JPEG",
      (pageWidth - 180) / 2,
      (pageHeight - 70) / 2,
      180,
      70
    );

    doc.setGState(new doc.GState({ opacity: 1 }));
  } catch (err) {
    console.warn("Watermark not found:", err);
  }

  // 🩶 Header
  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, pageWidth, 40, "F");

  try {
    doc.addImage(
      `${process.env.PUBLIC_URL}/optica-no-bg.png`,
      "JPEG",
      10,
      5,
      65,
      25
    );
  } catch (error) {
    console.warn("Logo not found");
  }

  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(16);
  doc.text("OPTICA INTERNATIONAL", 85, 15);
 doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text("932, Maradana Road, Colombo 08", 85, 23);
  doc.text("011 268 2277 / 077 344 0937 | opticainternational@gmail.com", 85, 29);


  // 🧾 Content
  doc.setTextColor(0, 0, 0);

  let yPos = 40;

  const labelX = 20;
  const valueX = 80;
  const lineHeight = 8;

  const drawSection = (title) => {
    doc.setFont(undefined, "bold");
    doc.setFontSize(9);

    doc.text(title, labelX, yPos);

    yPos += 6;

    doc.setLineWidth(0.3);
    doc.line(labelX, yPos, 190, yPos);

    yPos += 6;
  };

  const drawRow = (label, value) => {
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(9);

    doc.text(label, labelX, yPos);

     doc.setFont("Times New Roman", "normal");

    doc.text(String(value), valueX, yPos);

    yPos += lineHeight;
  };

  // Customer Info
  drawSection("Customer Information");

  drawRow("Customer Name:", purchase.customerName || "-");
  drawRow("Company:", purchase.company || "-");
  drawRow("Email:", purchase.email || "-");

  yPos += 3;

  // Product Info
  drawSection("Product Details");

  drawRow("Main Invoice No:", purchase.invoiceNumber || "-");

  drawRow("Product Name:", purchase.productName || "-");

  drawRow("Product Code:", purchase.productCode || "-");

  drawRow(
    "Product Price:",
    `Rs. ${Number(
      purchase.productPrice || 0
    ).toLocaleString()}`
  );

  yPos += 3;

  // Payment Info
  drawSection("Payment Details");

  drawRow(
    "Advance Payment:",
    `Rs. ${Number(
      purchase.advancePayment || 0
    ).toLocaleString()}`
  );

  drawRow(
    "Installments Paid:",
    purchase.installmentsPaid || 0
  );

  drawRow(
    "No. of Installments:",
    purchase.installmentMonths || "-"
  );

  drawRow(
    "Each Installment:",
    `Rs. ${Number(
      purchase.eachInstallment || 0
    ).toLocaleString()}`
  );

  yPos += 8;

  // 📋 Table Header
  const col1X = 20;
  const col2X = 60;
  const col3X = 130;

  const rowHeight = 10;

  const col1Width = 40;
  const col2Width = 70;
  const col3Width = 60;

  doc.setFillColor(0, 0, 0);

  doc.rect(20, yPos, pageWidth - 40, rowHeight, "F");

  doc.setTextColor(255, 255, 255);

  doc.setFontSize(9);

  doc.text("Sub Invoice Number", col1X + 5, yPos + 7);

  doc.text("Payment Date", col2X + 5, yPos + 7);

  doc.text(
    "Installment Amount (Rs.)",
    col3X + 5,
    yPos + 7
  );

  yPos += rowHeight;

  doc.setTextColor(0, 0, 0);

  // 📄 Table Rows
  payments.forEach((p) => {
    if (yPos > pageHeight - 40) {
      doc.addPage();
      yPos = 20;
    }

    doc.rect(col1X, yPos, col1Width, rowHeight);

    doc.rect(
      col1X + col1Width,
      yPos,
      col2Width,
      rowHeight
    );

    doc.rect(
      col1X + col1Width + col2Width,
      yPos,
      col3Width,
      rowHeight
    );

    const formattedDate = p.paymentDate
      ? new Date(
          p.paymentDate?.toDate
            ? p.paymentDate.toDate()
            : p.paymentDate
        ).toLocaleDateString()
      : "-";

    doc.text(
      String(p.subInvoiceNumber || "-"),
      col1X + 5,
      yPos + 7
    );

    doc.text(
      formattedDate,
      col2X + 5,
      yPos + 7
    );

    doc.text(
      `Rs. ${Number(
        p.installmentAmount || 0
      ).toLocaleString()}`,
      col3X + 5,
      yPos + 7
    );

    yPos += rowHeight;
  });

  // 💰 Financial Summary
  const totalPaid = payments.reduce(
    (sum, p) =>
      sum + (Number(p.installmentAmount) || 0),
    0
  );

  const advance =
    Number(purchase.advancePayment) || 0;

  const finalAmount =
    Number(
      purchase.finalAmount ||
        purchase.productPrice
    ) || 0;

  const totalAmountPaid = advance + totalPaid;

  const balance = finalAmount - totalAmountPaid;

  const formatCurrency = (val) =>
    `Rs. ${Number(val).toLocaleString()}`;

  if (yPos > pageHeight - 40) {
    doc.addPage();
    yPos = 20;
  }

  yPos += 10;

  const summaryLabelX = 20;
  const summaryValueX = 150;

  const drawSummaryRow = (
    label,
    value,
    bold = false
  ) => {
    doc.setFont(
      undefined,
      bold ? "bold" : "normal"
    );

    doc.setFontSize(8);

    doc.text(label, summaryLabelX, yPos);

    doc.text(value, summaryValueX, yPos, {
      align: "right",
    });

    yPos += 8;
  };

  drawSummaryRow(
    "Advance Payment:",
    formatCurrency(advance)
  );

  drawSummaryRow(
    "Installments Paid:",
    formatCurrency(totalPaid)
  );

  drawSummaryRow(
    "Total Paid:",
    formatCurrency(totalAmountPaid)
  );

  if (balance > 0) {
    doc.setTextColor(200, 0, 0);
  } else {
    doc.setTextColor(0, 150, 0);
  }

  drawSummaryRow(
    "Balance Amount:",
    formatCurrency(balance),
    true
  );

  doc.setTextColor(0, 0, 0);

  // 💙 Footer
  const footerHeight = 14;

  doc.setFillColor(0, 0, 0);

  doc.rect(
    0,
    pageHeight - footerHeight,
    pageWidth,
    footerHeight,
    "F"
  );

  doc.setTextColor(255, 255, 255);

  doc.setFontSize(9);

  doc.text(
    "Thank you for your payment!",
    pageWidth / 2,
    pageHeight - 8,
    {
      align: "center",
    }
  );

  // 💾 Save
  doc.save(
    `AllPayments_${purchase.customerName}_${Date.now()}.pdf`
  );
};










 
  useEffect(() => {
  let filtered = [...purchasedItems];

  // Exact Date Filter
  if (reportDate) {
    filtered = filtered.filter(
      (item) => item.purchaseDate === reportDate
    );
  }

  // Month Filter
  if (reportMonth) {
    filtered = filtered.filter((item) => {
      if (!item.purchaseDate) return false;

      const date = new Date(item.purchaseDate);

      return (
        String(date.getMonth() + 1).padStart(2, "0") === reportMonth
      );
    });
  }

  // Year Filter
  if (reportYear) {
    filtered = filtered.filter((item) => {
      if (!item.purchaseDate) return false;

      const date = new Date(item.purchaseDate);

      return String(date.getFullYear()) === reportYear;
    });
  }

  setReportFilteredData(filtered);

}, [reportDate, reportMonth, reportYear, purchasedItems]);























//////////////////////////// payment details as individual in Customer Payment Details //////////////////////////

  const [customerPayments, setCustomerPayments] = useState([]);

  useEffect(() => {
    if (selectedOption === "paymentDetails") {
      fetchAllPayments();
    }
  }, [selectedOption]);

  const fetchAllPayments = async () => {
    setLoading(true);

    try {
      // Fetch from purchased_products
      const purchaseSnap = await getDocs(collection(db, "purchased_products"));
      const purchaseData = purchaseSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Fetch from payments
      const paymentsSnap = await getDocs(collection(db, "payments"));
      const paymentsData = paymentsSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Group payments by productCode + customer email
      const grouped = purchaseData.map((purchase) => {
        const relatedPayments = paymentsData.filter(
          (p) =>
            p.productCode === purchase.productCode &&
            p.email === purchase.email
        );
        return { ...purchase, payments: relatedPayments };
      });

      // Group by customer (name+email)
      const customersMap = {};
      grouped.forEach((p) => {
        const key = `${p.customerName}_${p.email}`;
        if (!customersMap[key]) {
          customersMap[key] = {
            customerName: p.customerName,
            email: p.email,
            purchases: [],
          };
        }
        customersMap[key].purchases.push(p);
      });

      setCustomerPayments(Object.values(customersMap));
    } catch (error) {
      console.error("Error fetching payment details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentSlipDownload = (purchase) => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // HEADER
    doc.setFillColor(30, 144, 255);
    doc.rect(0, 0, pageWidth, 35, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(16);
    doc.text("OPTICA INTERNATIONAL", 50, 15);
    doc.setFontSize(10);
    doc.text("932, Maradana Road, Colombo 08", 50, 23);

    // Title
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(14);
    doc.text("PAYMENT STATEMENT", pageWidth / 2, 50, { align: "center" });

    // Product & Customer Details
    let y = 65;
    const details = [
      ["Customer Name", purchase.customerName],
      ["Email", purchase.email],
      ["Company", purchase.company],
      ["Product Name", purchase.productName],
      ["Product Code", purchase.productCode],
      ["Invoice No", purchase.invoiceNumber],
      ["Product Price", `Rs. ${purchase.productPrice || 0}`],
      ["Advance Payment", `Rs. ${purchase.advancePayment || 0}`],
      ["Installments Paid", purchase.installmentsPaid || 0],
      ["Outstanding Amount", `Rs.${(purchase.finalAmount || 0) - ((purchase.advancePayment || 0) + (purchase.installmentsPaidAmount || 0))}`],
    ];
    details.forEach(([label, value]) => {
      doc.setFont("helvetica", "bold");
      doc.text(`${label}:`, 15, y);
      doc.setFont("helvetica", "normal");
      doc.text(String(value), 80, y);
      y += 7;
    });

    // Payment Table
    const tableRows = (purchase.payments || []).map((p) => [
      p.paymentDate || "-",
      p.installmentAmount || 0,
    ]);
    autoTable(doc, {
      startY: y + 10,
      head: [["Payment Date", "Installment Amount (Rs.)"]],
      body: tableRows,
      headStyles: { fillColor: [30, 144, 255], textColor: 255 },
    });

    doc.save(`PaymentSlip_${purchase.invoiceNumber || "NoNumber"}.pdf`);
  };


const [searchName, setSearchName] = useState("");
const [searchEmail, setSearchEmail] = useState("");
const [searchInvoice, setSearchInvoice] = useState("");


const filteredCustomers = customerPayments.filter((customer) => {
  const nameMatch = customer.customerName
    ?.toLowerCase()
    .includes(searchName.toLowerCase());

  const emailMatch = customer.email
    ?.toLowerCase()
    .includes(searchEmail.toLowerCase());

  const invoiceMatch = customer.purchases?.some((purchase) =>
    purchase.invoiceNumber
      ?.toLowerCase()
      .includes(searchInvoice.toLowerCase())
  );

  return (
    (!searchName || nameMatch) &&
    (!searchEmail || emailMatch) &&
    (!searchInvoice || invoiceMatch)
  );
});
  



{/**************************************************  sales report ***************************************************************/}
 const [sales, setSales] = useState([]);
  const [filtered, setFiltered] = useState([]);

  // Filters
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
 

  // Totals
  const [totalSales, setTotalSales] = useState(0);
  const [totalAdvance, setTotalAdvance] = useState(0);

  // 🔥 REAL-TIME FETCH
  useEffect(() => {
    const q = query(
      collection(db, "purchased_products"),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSales(data);
      setFiltered(data);
      calculateTotals(data);
    });

    return () => unsubscribe();
  }, []);

  // 🔎 APPLY FILTERS
  const applyFilters = () => {
    let data = [...sales];

    if (fromDate)
      data = data.filter((s) => s.date >= fromDate);

    if (toDate)
      data = data.filter((s) => s.date <= toDate);

    if (paymentType)
      data = data.filter((s) => s.paymentType === paymentType);

    if (company)
      data = data.filter((s) =>
        s.company?.toLowerCase().includes(company.toLowerCase())
      );

    setFiltered(data);
    calculateTotals(data);
  };

  // 📊 TOTAL CALCULATIONS
  const calculateTotals = (data) => {
    let salesTotal = 0;
    let advanceTotal = 0;

    data.forEach((item) => {
      salesTotal += item.productPrice || 0;
      advanceTotal += item.advancePayment || 0;
    });

    setTotalSales(salesTotal);
    setTotalAdvance(advanceTotal);
  };


const [stockHistory, setStockHistory] = useState([]);

useEffect(() => {
  let data = [...sales];

  if (fromDate)
    data = data.filter((s) => s.date >= fromDate);

  if (toDate)
    data = data.filter((s) => s.date <= toDate);

  if (paymentType)
    data = data.filter((s) => s.paymentType === paymentType);

  if (company)
    data = data.filter((s) =>
      s.company?.toLowerCase().includes(company.toLowerCase())
    );

  setFiltered(data);
  calculateTotals(data);
}, [sales, fromDate, toDate, paymentType, company]);

 

/////////////////////////////// sales report in pdf //////////////////////////////////////////
const salesByCompany = {};

filtered.forEach((item) => {
  const company = item.company || "Unknown";

  if (!salesByCompany[company]) salesByCompany[company] = 0;

  salesByCompany[company] += item.productPrice || 0;
});

const chartData = {
  labels: Object.keys(salesByCompany),
  datasets: [
    {
      label: "Sales Amount (Rs.)",
      data: Object.values(salesByCompany),
      backgroundColor: "#1e90ff",
    },
  ],
};


const downloadSalesReport = () => {

  if (filtered.length === 0) {
    alert("No sales data found.");
    return;
  }

  const reportData = filtered.map((item, index) => ({
    "No": index + 1,
    "Date": item.date || "-",
    "Invoice No": item.invoiceNumber || "-",
    "Customer": item.customerName || "-",
    "Company": item.company || "-",
    "Product": item.productName || "-",
    "Payment Type": item.paymentType || "-",
    "Unit Price (Rs.)": item.productPrice || 0,
    "Advance (Rs.)": item.advancePayment || 0,
    "Total Amount (Rs.)": item.finalAmount || 0,
  }));

  // Add Summary Row
  reportData.push({});
  reportData.push({
    "Customer": "TOTAL SALES",
    "Unit Price (Rs.)": totalSales,
  });

  reportData.push({
    "Customer": "TOTAL ADVANCE",
    "Advance (Rs.)": totalAdvance,
  });

  // Worksheet
  const worksheet = XLSX.utils.json_to_sheet(reportData);

  worksheet["!cols"] = [
    { wch: 8 },
    { wch: 15 },
    { wch: 18 },
    { wch: 25 },
    { wch: 25 },
    { wch: 25 },
    { wch: 18 },
    { wch: 18 },
    { wch: 18 },
    { wch: 20 },
  ];

  // Workbook
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Sales Report"
  );

  // Excel File
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  const fileName = `Sales_Report_${new Date().getTime()}.xlsx`;

  saveAs(data, fileName);
};






/////////////////////////////// stock history   //////////////////////////////////////////////

const [submissions, setSubmissions] = useState([]);
const [filters, setFilters] = useState({
  feeType: '',
  month: '',
  name: ''
});


  const [filteredHistory, setFilteredHistory] = useState([]);
  const [filterFrom, setFilterFrom] = useState("");
  const [filterTo, setFilterTo] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [filterToday, setFilterToday] = useState(false);

  // ----- FETCH ALL STOCK HISTORY -----
  useEffect(() => {
    const q = query(collection(db, "stock_history"), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setStockHistory(data);
      setFilteredHistory(data);
    });
    return () => unsubscribe();
  }, []);

  // ----- FILTER FUNCTION -----
  useEffect(() => {
    let filtered = [...stockHistory];

    // 1️⃣ Filter by today
    if (filterToday) {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);

      filtered = filtered.filter(item => {
        const date = item.createdAt?.toDate();
        return date >= todayStart && date <= todayEnd;
      });
    }

    // 2️⃣ Filter by date range
    if (filterFrom && filterTo) {
      const from = new Date(filterFrom);
      from.setHours(0, 0, 0, 0);
      const to = new Date(filterTo);
      to.setHours(23, 59, 59, 999);

      filtered = filtered.filter(item => {
        const date = item.createdAt?.toDate();
        return date >= from && date <= to;
      });
    }

    // 3️⃣ Filter by month & year
    if (filterMonth && filterYear) {
      filtered = filtered.filter(item => {
        const date = item.createdAt?.toDate();
        return date?.getMonth() + 1 === Number(filterMonth) && date?.getFullYear() === Number(filterYear);
      });
    }

    setFilteredHistory(filtered);
  }, [filterFrom, filterTo, filterMonth, filterYear, filterToday, stockHistory]);

  // ----- RESET FILTERS -----
  const handleClearFilters = () => {
    setFilterFrom("");
    setFilterTo("");
    setFilterMonth("");
    setFilterYear("");
    setFilterToday(false);
  };





const downloadStockHistoryPDF = () => {
  const doc = new jsPDF();

  doc.setFontSize(16);
  doc.text("Stock History Report", 14, 15);

  doc.setFontSize(10);
  doc.text(`From: ${filterFrom || "All"}   To: ${filterTo || "All"}`, 14, 22);

  const tableData = filteredHistory.map(item => [
    item.productName,
    item.productCode,
    item.quantityChanged,
    item.type,
    item.customerName || "-",
    item.company || "-",
    item.createdAt ? item.createdAt.toDate().toLocaleString() : "-"
  ]);

  // ===== Advanced Summary Calculations =====

  let totalIn = 0;
  let totalOut = 0;
  let totalTransactions = filteredHistory.length;
  let totalSales = 0;
  let totalStockAdditions = 0;

  const productSet = new Set();

  filteredHistory.forEach(item => {
    productSet.add(item.productCode);

    if (item.type === "IN") {
      totalIn += Number(item.quantityChanged);
      totalStockAdditions++;
    }

    if (item.type === "OUT") {
      totalOut += Number(item.quantityChanged);
      totalSales++;
    }
  });

  const netStockChange = totalIn - totalOut;
  const uniqueProducts = productSet.size;

autoTable(doc, {
  head: [[
    "Product Name",
    "Code",
    "Qty",
    "Type",
    "Customer",
    "Company",
    "Date / Time"
  ]],
  body: tableData,
  startY: 30,

  headStyles: {
    fillColor: [0, 0, 0],   // Background color (Navy Blue)
    textColor: [255, 255, 255] // Heading text color (White)
  }
});

  const finalY = doc.lastAutoTable.finalY + 12;

  doc.setFontSize(13);
  doc.text("Stock Movement Summary", 14, finalY);

  doc.setFontSize(10);

  doc.text(`Total Transactions : ${totalTransactions}`, 14, finalY + 10);
  doc.text(`Unique Products Affected : ${uniqueProducts}`, 14, finalY + 18);

 
  doc.text(`Total Stock Sold/Removed (OUT) : ${totalOut}`, 14, finalY + 26);


  doc.save(`Stock_History_Report_${Date.now()}.pdf`);
};







///************************* payment submission ******************************/}

useEffect(() => {
  const fetchSubmissions = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "formSubmissions"));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Sort by submit date (newest first)
      const sortedData = data.sort((a, b) => {
        // Get submit dates for comparison
        const getSubmitDate = (sub) => {
          if (sub.submittedAt?.seconds) {
            return new Date(sub.submittedAt.seconds * 1000);
          }
          if (sub.submittedAt) {
            return new Date(sub.submittedAt);
          }
          if (sub.date) {
            return new Date(sub.date);
          }
          return new Date(0); // Fallback for submissions without date
        };

        const dateA = getSubmitDate(a);
        const dateB = getSubmitDate(b);
        
        return dateB - dateA; // Descending order (newest first)
      });

      setSubmissions(sortedData);
    } catch (error) {
      console.error("Error fetching submissions:", error);
    }
  };

  fetchSubmissions();
}, []);



const filteredSubmissions = submissions.filter(submission => {

  // Fee Type filter
  if (filters.feeType && submission.feeType !== filters.feeType) {
    return false;
  }

  // Month filter
  if (filters.month) {
    const submissionDate = submission.submittedAt?.seconds
      ? new Date(submission.submittedAt.seconds * 1000)
      : new Date(submission.date || submission.submittedAt);

    const submissionMonth = submissionDate.getMonth() + 1;
    if (submissionMonth !== parseInt(filters.month)) {
      return false;
    }
  }

  // Name filter
  if (
    filters.name &&
    !submission.name?.toLowerCase().includes(filters.name.toLowerCase())
  ) {
    return false;
  }

  // ✅ STATUS FILTER
  if (filters.status) {
    const currentStatus = (submission.status || "pending").toLowerCase();
    if (currentStatus !== filters.status.toLowerCase()) {
      return false;
    }
  }

  return true;
});

// Get unique fee types for dropdown
const uniqueFeeTypes = [...new Set(submissions.map(sub => sub.feeType))].filter(Boolean);


 
  





// Add this function to update status in Firestore
const updateSubmissionStatus = async (submissionId, newStatus) => {
  try {
    await updateDoc(doc(db, "formSubmissions", submissionId), {
      status: newStatus,
      updatedAt: new Date()
    });
    // Update local state to reflect changes immediately
    setSubmissions(submissions.map(sub => 
      sub.id === submissionId ? {...sub, status: newStatus} : sub
    ));
  } catch (error) {
    console.error("Error updating status:", error);
    alert("Failed to update status");
  }
};





//////////////////////////////// process ////////////////////

/* ================= PROCESS PANEL ================= */

// ================= PROCESS STATES =================
const [processProducts, setProcessProducts] = useState([]);
const [processRecords, setProcessRecords] = useState([]);
// ================= EXTRA STATES =================
const [editProcessId, setEditProcessId] = useState(null);



const [processForm, setProcessForm] = useState({
  date: "",
  productCode: "",
  availableStock: "",
  qty: "",
  remarks: "",
  status: "In Stock",
});

const [statusUpdateDate, setStatusUpdateDate] = useState({});

const processStatusList = [
  "In Stock",
  "Out for Screen Print",
  "Delivered",
  "Received by Customer",
  "return to EC",
];


// ================= FETCH PRODUCTS =================
const fetchProcessProducts = async () => {
  try {
    const snap = await getDocs(collection(db, "new_products"));

    const data = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setProcessProducts(data);
  } catch (error) {
    console.log(error);
  }
};


// ================= FETCH PROCESS RECORDS =================
const fetchProcessRecords = async () => {
  try {
    const snap = await getDocs(collection(db, "process"));

    const data = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setProcessRecords(data);
  } catch (error) {
    console.log(error);
  }
};


// ================= LOAD DATA =================
useEffect(() => {
  if (selectedOption === "process") {
    fetchProcessProducts();
    fetchProcessRecords();
  }
}, [selectedOption]);


// ================= SELECT PRODUCT =================
const handleProcessProduct = (e) => {
  const code = e.target.value;

  const selected = processProducts.find(
    (item) => item.productCode === code
  );

  setProcessForm({
    ...processForm,
    productCode: code,
    availableStock:
      selected?.stock ||
      selected?.qty ||
      selected?.availableStock ||
      0,
  });
};


// ================= SAVE =================
// ================= SAVE / UPDATE =================
const saveProcessRecord = async () => {
  try {
    if (!processForm.date) {
      alert("Please select date");
      return;
    }

    if (!processForm.productCode) {
      alert("Please select product code");
      return;
    }

    if (!processForm.qty) {
      alert("Please enter quantity");
      return;
    }

    // UPDATE
    if (editProcessId) {
      await updateDoc(doc(db, "process", editProcessId), {
        ...processForm,
      });

      alert("Updated Successfully");
      setEditProcessId(null);
    }

    // NEW SAVE
    else {
      await addDoc(collection(db, "process"), {
        ...processForm,
        status: "In Stock",
        createdAt: new Date(),
        history: [
          {
            date: processForm.date,
            status: "In Stock",
          },
        ],
      });

      alert("Saved Successfully");
    }

    setProcessForm({
      date: "",
      productCode: "",
      availableStock: "",
      qty: "",
      remarks: "",
      status: "In Stock",
    });

    fetchProcessRecords();

  } catch (error) {
    console.log(error);
  }
};



// ================= UPDATE STATUS =================
const updateProcessStatus = async (item, status) => {
  try {
    const selectedDate =
      statusUpdateDate[item.id] ||
      new Date().toISOString().split("T")[0];

    const ref = doc(db, "process", item.id);

    const oldHistory = item.history || [];

    const newHistory = [
      ...oldHistory,
      {
        date: selectedDate,
        status: status,
      },
    ];

    await updateDoc(ref, {
      status: status,
      date: selectedDate,
      history: newHistory,
    });

    fetchProcessRecords();
  } catch (error) {
    console.log(error);
  }
};




// ================= EDIT =================
const editProcessRecord = (item) => {
  setProcessForm({
    date: item.date || "",
    productCode: item.productCode || "",
    availableStock: item.availableStock || "",
    qty: item.qty || "",
    remarks: item.remarks || "",
    status: item.status || "In Stock",
  });

  setEditProcessId(item.id);
};


// ================= DELETE =================
const deleteProcessRecord = async (id) => {
  const confirmDelete = window.confirm("Delete this record?");

  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "process", id));
    fetchProcessRecords();
  } catch (error) {
    console.log(error);
  }
};







  return (
    <div className="admin-container">
      {/* Sidebar */}
      <div className="admin-sidebar">
        <h2 className="admin-sidebar-title">Optica International - Admin Panel</h2>
        <ul className="admin-sidebar-list">
          <li onClick={() => setSelectedOption("createAccount")}>Create Customer Account</li>

          <li onClick={toggleUserDropdown} style={{ cursor: "pointer" }}>
            Customer Management {isUserDropdownOpen ? "▼" : "▶"}
          </li>

          {isUserDropdownOpen && (
            <ul style={{ paddingLeft: "20px" }}>
              <li onClick={() => setSelectedOption("viewAllUsers")}>View All Customers</li>
              <li onClick={() => setSelectedOption("editUser")}>Edit All Customers</li>
              <li onClick={() => setSelectedOption("ProductPurchasing")}>Product Purchasing</li>
              <li onClick={() => setSelectedOption("viewAddedProduct")}>View All Purchased Product</li>
            </ul>
          )}
        <li onClick={toggleProductDropdown} style={{ cursor: "pointer" }}>
            Product Management {isUserDropdownOpen ? "▼" : "▶"}
          </li>

          
           {isProductDropdownOpen && (
            <ul style={{ paddingLeft: "20px" }}>
          <li onClick={() => setSelectedOption("addNewProduct")}>Add New Product</li>
           <li onClick={() => setSelectedOption("viewAllProduct")}>View All Product / View Stock</li>
          </ul>
          )}

          <li onClick={() => setSelectedOption("process")}>Stock Process</li>
          <li onClick={() => setSelectedOption("viewallpaymentsubmissions")}>View All Payment Submissions</li>
          <li onClick={() => setSelectedOption("updatePayments")}>Update Customer Payments</li>
          <li onClick={() => setSelectedOption("paymentDetails")}>Customer Payment Details</li>
          <li onClick={() => setSelectedOption("StockHistory")}>Stock History</li>
          <li onClick={() => setSelectedOption("SalesReport")}>Sales Report</li>
          <li className="logout-button" onClick={handleLogout}>Logout</li>
        </ul>
      </div>




















      {/* Main Panel */}
      <div className="admin-panel">


{/***************************************** stock Out For Screen Print *********************************************************/}

{selectedOption === "process" && (
  <div className="admin-panel-wrapper">

    <h1 className="admin-panel-title">Process Panel</h1>

    {/* FORM SECTION */}
    <div className="admin-form-grid">

      <input
        type="date"
        value={processForm.date}
        onChange={(e) =>
          setProcessForm({
            ...processForm,
            date: e.target.value,
          })
        }
      />

      <select
        value={processForm.productCode}
        onChange={handleProcessProduct}
      >
        <option value="">Select Product Code</option>

        {processProducts.map((item) => (
          <option key={item.id} value={item.productCode}>
            {item.productCode}
          </option>
        ))}
      </select>

      <input
        type="text"
        placeholder="Available Stock"
        value={processForm.availableStock}
        onChange={(e) =>
          setProcessForm({
            ...processForm,
            availableStock: e.target.value,
          })
        }
      />

      <input
        type="number"
        placeholder="Qty"
        value={processForm.qty}
        onChange={(e) =>
          setProcessForm({
            ...processForm,
            qty: e.target.value,
          })
        }
      />

      <input
        type="text"
        placeholder="Remarks"
        value={processForm.remarks}
        onChange={(e) =>
          setProcessForm({
            ...processForm,
            remarks: e.target.value,
          })
        }
      />

      <button onClick={saveProcessRecord}>
        Save Process
      </button>

    </div>


    {/* TABLE CONTAINER */}
    <div className="process-table-container">

      <table className="process-table">

<thead>
  <tr>
    <th>Code</th>
    <th>Date</th>
    <th>Stock</th>
    <th>Qty</th>
    <th>Status</th>
    <th>Remarks</th>
    <th>Update Date</th>
    <th>Status Actions</th>
    <th>History</th>
    <th>Action</th>
  </tr>
</thead>

        <tbody>

          {processRecords.map((item) => (
            <tr key={item.id}>

              <td>{item.productCode}</td>
              <td>{item.date}</td>
              <td>{item.availableStock}</td>
              <td>{item.qty}</td>
              <td>{item.status}</td>
              <td>{item.remarks}</td>

              <td>
                <input
                  type="date"
                  value={statusUpdateDate[item.id] || ""}
                  onChange={(e) =>
                    setStatusUpdateDate({
                      ...statusUpdateDate,
                      [item.id]: e.target.value,
                    })
                  }
                />
              </td>

              <td>
                <div className="status-btn-wrap">
                  {processStatusList.map((status, i) => (
                    <button
                      key={i}
                      onClick={() =>
                        updateProcessStatus(item, status)
                      }
                    >
                      {status}
                    </button>
                  ))}
                </div>
              </td>

              <td>
                <div className="history-scroll">
                  {(item.history || []).map((h, index) => (
                    <p key={index}>
                      {h.date} - {h.status}
                    </p>
                  ))}
                </div>
              </td>


<td>
  <div className="action-btn-wrap">
    <button onClick={() => editProcessRecord(item)}>
      Edit
    </button>

    <button onClick={() => deleteProcessRecord(item.id)}>
      Delete
    </button>
  </div>
</td>


            </tr>
          ))}

        </tbody>

      </table>

    </div>

  </div>
)}



{/***************************************************  create account **********************************************************/}




        {selectedOption === "createAccount" && (
          <>
            <h1 className="admin-panel-title">Create Customer Account</h1>
            <div className="admin-panel-form">
              <input
                type="email"
                className="admin-panel-input"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <div style={{ position: "relative", width: "100%" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="admin-panel-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>

              <select
                className="admin-panel-select"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="">Select Role</option>
                <option value="customer">Customer</option>
              </select>

              <input
                type="text"
                className="admin-panel-input"
                placeholder="Name with Initials"
                value={nameWithInitial}
                onChange={(e) => setNameWithInitial(e.target.value)}
              />

              <input
                type="text"
                className="admin-panel-input"
                placeholder="Company Name"
                value={companyname}
                onChange={(e) => setCompanyname(e.target.value)}
              />

              <input
                type="text"
                className="admin-panel-input"
                placeholder="Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />

              <input
                type="text"
                className="admin-panel-input"
                placeholder="NIC Number"
                value={nicPassport}
                onChange={(e) => setNicPassport(e.target.value)}
              />

              <input
                type="tel"
                className="admin-panel-input"
                placeholder="Contact Number"
                value={contactNo}
                onChange={(e) =>
                  setContactNo(e.target.value.replace(/\D/g, "").slice(0, 10))
                }
              />

              <button className="admin-panel-button" onClick={createAccount}>
                Create Account
              </button>
            </div>
          </>
        )}







{/***********************************************************************************************************/}

{selectedOption === "viewallpaymentsubmissions" && (
  <div className="psub-tab-content">
    <h3 className="psub-title">View All Payment Submissions</h3>

    {/* ================= Filters ================= */}
    <div className="psub-filters">
      <div className="filter-group">
        <label>NAME</label>
        <input
          type="text"
          className="form-control"
          placeholder="Type a name..."
          value={filters.name}
          onChange={(e) => setFilters({ ...filters, name: e.target.value })}
        />
      </div>

        <div className="col-md-4">
          <label>Status:</label>
          <select
            className="form-control"
            value={filters.status}
            onChange={(e) =>
              setFilters({ ...filters, status: e.target.value })
            }
          >
            <option value="">All Status</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>


      <div className="filter-group">
        <label>FEE TYPE</label>
        <select
          className="form-control"
          value={filters.feeType}
          onChange={(e) => setFilters({ ...filters, feeType: e.target.value })}
        >
          <option value="">All Fee Types</option>
          {uniqueFeeTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label>MONTH</label>
        <select
          className="form-control"
          value={filters.month}
          onChange={(e) => setFilters({ ...filters, month: e.target.value })}
        >
          <option value="">All Months</option>
          <option value="1">January</option>
          <option value="2">February</option>
          <option value="3">March</option>
          <option value="4">April</option>
          <option value="5">May</option>
          <option value="6">June</option>
          <option value="7">July</option>
          <option value="8">August</option>
          <option value="9">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
      </div>

      <div className="filter-group filter-button">

          <button
            className="btn btn-secondary"
            onClick={() =>
              setFilters({
                feeType: "",
                month: "",
                name: "",
                status: ""
              })
            }
          >
            Clear Filters
          </button>

      </div>
    </div>

    {/* ================= Table ================= */}
    {filteredSubmissions.length === 0 ? (
      <p className="psub-empty">No submissions found matching your filters.</p>
    ) : (
      <div className="psub-table-wrapper">
        <table className="psub-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Fee Type</th>
              <th>Application</th>
              <th>Payment Slip</th>
              <th>Status</th>
              <th>Actions</th>
              <th>Submitted At</th>
            </tr>
          </thead>
          <tbody>
            {filteredSubmissions.map((submission) => (
              <tr key={submission.id}>
                <td>{submission.email}</td>
                <td>{submission.feeType}</td>
                <td>
                  {submission.applicationFileUrl ? (
                    <a
                      href={submission.applicationFileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="psub-file-link"
                    >
                      View
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>
                  {submission.paymentSlipUrl ? (
                    <a
                      href={submission.paymentSlipUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="psub-file-link"
                    >
                      View
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>
                  <span
                    className={`psub-status ${
                      (submission.status || "pending").toLowerCase()
                    }`}
                  >
                    {submission.status || "Pending"}
                  </span>
                </td>
                <td className="psub-actions">
                  {(submission.status || "pending").toLowerCase() === "pending" && (
                    <>
                      <button
                        className="psub-btn approve"
                        onClick={() =>
                          updateSubmissionStatus(submission.id, "Approved")
                        }
                      >
                        Approve
                      </button>
                      <button
                        className="psub-btn reject"
                        onClick={() =>
                          updateSubmissionStatus(submission.id, "Rejected")
                        }
                      >
                        Reject
                      </button>
                    </>
                  )}
                  <button
                    className="psub-btn delete"
                    onClick={() => {
                      if (window.confirm("Delete this submission?")) {
                        deleteDoc(doc(db, "formSubmissions", submission.id)).then(
                          () => {
                            setSubmissions(
                              submissions.filter((s) => s.id !== submission.id)
                            );
                          }
                        );
                      }
                    }}
                  >
                    Delete
                  </button>
                </td>
                <td>
                  {submission.submittedAt?.seconds
                    ? new Date(
                        submission.submittedAt.seconds * 1000
                      ).toLocaleString()
                    : new Date(
                        submission.date || submission.submittedAt
                      ).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
)}


{/************************************ stock history *********************************************/}



{selectedOption === "StockHistory" && (
  <div className="stock-history-container">
      <h1 className="admin-panel-title">Stock History</h1>

      {/* Filter Section */}
      <div className="filter-section">
        <label>
          From:
          <input type="date" value={filterFrom} onChange={e => setFilterFrom(e.target.value)} />
        </label>
        <label>
          To:
          <input type="date" value={filterTo} onChange={e => setFilterTo(e.target.value)} />
        </label>


        <button onClick={handleClearFilters}>Clear Filters</button>
          <button onClick={downloadStockHistoryPDF}>
    Download PDF
  </button>

      </div>

      {/* Table */}
      <div className="product-table-container">
        <table className="stock-history-table">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Code</th>
              <th>Qty</th>
              <th>Type</th>
              <th>Customer</th>
              <th>Company</th>
              <th>Date / Time</th>
            </tr>
          </thead>
          <tbody>
            {filteredHistory.length > 0 ? (
              filteredHistory.map(item => (
                <tr key={item.id}>
                  <td>{item.productName}</td>
                  <td>{item.productCode}</td>
                  <td>{item.quantityChanged}</td>
                  <td>{item.type}</td>
                  <td>{item.customerName || "-"}</td>
                  <td>{item.company || "-"}</td>
                  <td>{item.createdAt ? item.createdAt.toDate().toLocaleString() : "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>No stock history found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
)}






{/************************************ sales report *********************************************/}

{selectedOption === "SalesReport" && (
 <div className="report-container">
      <h2>📊 Sales Report</h2>

      {/* 🔎 FILTERS */}
     <div className="filters">
  <input
    type="date"
    value={fromDate}
    onChange={(e) => setFromDate(e.target.value)}
  />

  <input
    type="date"
    value={toDate}
    onChange={(e) => setToDate(e.target.value)}
  />

  <select
    value={paymentType}
    onChange={(e) => setPaymentType(e.target.value)}
  >
    <option value="">All Payments</option>
    <option value="advance">Advance</option>
    <option value="installment">Installment</option>
  </select>

  <input
    type="text"
    placeholder="Company"
    value={company}
    onChange={(e) => setCompany(e.target.value)}
  />

  <button
    onClick={() => {
      setCompany("");
      setPaymentType("");
      setFromDate("");
      setToDate("");
    }}
  >
    Clear
  </button>


  <button
  className="download-report-btn"
  onClick={downloadSalesReport}
>
  Download Excel
</button>

</div>



      {/* 📊 SUMMARY */}
      <div className="summary">
        <p><strong>Total Sales:</strong> Rs. {totalSales.toLocaleString()}</p>
        <p><strong>Total Advance:</strong> Rs. {totalAdvance.toLocaleString()}</p>
      </div>

      {/* 📋 TABLE */}
      <table className="report-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Invoice</th>
            <th>Customer</th>
            <th>Company</th>
            <th>Product</th>
            <th>Payment</th>
            <th>Price</th>
            <th>Advance</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((item) => (
            <tr key={item.id}>
              <td>{item.date}</td>
              <td>{item.invoiceNumber}</td>
              <td>{item.customerName}</td>
              <td>{item.company}</td>
              <td>{item.productName}</td>
              <td>{item.paymentType}</td>
              <td>{item.productPrice?.toLocaleString()}</td>
              <td>{item.advancePayment?.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
)}


















{/******************************************************************* view All Users *************************************************************/}

{selectedOption === "viewAllUsers" && (
  <>
    <h1 className="admin-panel-title">View All Users</h1>
    {Object.keys(groupedUsers).length > 0 ? (
      renderUsersByRole()
    ) : (
      <p style={{ textAlign: "center", marginTop: "20px" }}>
        No users found in the database.
      </p>
    )}
  </>
)}



{/******************************************************************* Edit Users *************************************************************/}


 {selectedOption === "editUser" && (
        <>
          <h1 className="admin-panel-title">Edit Customer Details</h1>

          {editableUsers.length > 0 ? (
            <div className="edit-users-container">
              <table className="user-table">
                <thead>
                  <tr>
                    <th>Email (Read Only)</th>
                    <th>Name with Initials</th>
                    <th>Company</th>
                    <th>Address</th>
                    <th>NIC/Passport</th>
                    <th>Contact No</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {editableUsers.map((user) => {
                    const isEditing = editingUserId === user.id;
                    return (
                      <tr key={user.id}>
                        <td>
                          <input
                            type="email"
                            value={user.email || ""}
                            readOnly
                            className="readonly-input"
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            value={user.nameWithInitial || ""}
                            onChange={(e) =>
                              handleEditChange(
                                user.id,
                                "nameWithInitial",
                                e.target.value
                              )
                            }
                            readOnly={!isEditing}
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            value={user.companyname || ""}
                            onChange={(e) =>
                              handleEditChange(
                                user.id,
                                "companyname",
                                e.target.value
                              )
                            }
                            readOnly={!isEditing}
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            value={user.address || ""}
                            onChange={(e) =>
                              handleEditChange(
                                user.id,
                                "address",
                                e.target.value
                              )
                            }
                            readOnly={!isEditing}
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            value={user.nicPassport || ""}
                            onChange={(e) =>
                              handleEditChange(
                                user.id,
                                "nicPassport",
                                e.target.value
                              )
                            }
                            readOnly={!isEditing}
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            value={user.contactNo || ""}
                            onChange={(e) =>
                              handleEditChange(
                                user.id,
                                "contactNo",
                                e.target.value
                              )
                            }
                            readOnly={!isEditing}
                          />
                        </td>



                        <td>
                          <div className="action-buttons">
                            <div className="action-left">
                              {isEditing ? (
                                <>
                                  <button
                                    className="action-btn save-btn"
                                    onClick={() => handleSaveUser(user.id)}
                                  >
                                    Save
                                  </button>
                                  <button
                                    className="action-btn cancel-btn"
                                    onClick={handleCancelClick}
                                  >
                                    Cancel
                                  </button>
                                </>
                              ) : (
                                <button
                                  className="action-btn edit-btn"
                                  onClick={() => handleEditClick(user.id)}
                                >
                                  Edit
                                </button>
                              )}
                            </div>
                            <div className="action-right">
                              <button
                                className="action-btn delete-btn"
                                onClick={() => handleDeleteUser(user.id)}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <p style={{ textAlign: "center", marginTop: "20px" }}>
              No users available to edit.
            </p>
          )}
        </>
      )}


{/******************************************************************* Product Purchasing *************************************************************/}
  {selectedOption === "ProductPurchasing" && (
        <div className="add-product-container">
          <h1 className="add-product-heading">Product Purchasing</h1>

          <div className="add-product-scroll">
            <form className="add-product-form" onSubmit={handleAddProduct}>
              {/* Invoice Number and Date */}
              <div className="form-group">
                <label>Invoice Number</label>
                <input type="text" value={invoiceNumber} disabled />
              </div>




              <div className="form-group">
  <label>Date</label>
  <input
    type="date"
    value={date}
    onChange={(e) => setDate(e.target.value)}
  />
</div>


              {/* Customer Name */}
              <div className="form-group">
                <label>Customer Name</label>
                <input
                  type="text"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                  required
                />
              </div>

              {/* Email */}
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {/* Company */}
              <div className="form-group">
                <label>Company</label>
                <input
                  type="text"
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  required
                />
              </div>

              {/* Product Dropdown */}
              <div className="form-group">
                <label>Product Name</label>
                <select
                  value={selectedProduct}
                  onChange={handleProductChange}
                  required
                >
                  <option value="">Select Product</option>
                  {productList.map((p) => (
                    <option key={p.id} value={p.productName}>
                      {p.productName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Product Code */}
              <div className="form-group">
                <label>Product Code</label>
                <input type="text" value={productCode} disabled />
              </div>

              {/* Product Price */}
              <div className="form-group">
                <label>Product Price (Rs.)</label>
                <input
                  type="number"
                  value={productPrice}
                  onChange={(e) => setProductPrice(e.target.value)}
                  required
                />
              </div>




            <div className="form-group">
              <label>Quantity</label>
              {/* <input
                type="number"
                min="1"
                value={sellQuantity}
                onChange={(e) => setSellQuantity(e.target.value)}
                required
              /> */}

              <input
                type="number"
                value={sellQuantity}
                onChange={handleQuantityChange}
                min="1"
              />
            </div>



            <div className="form-group">
              <label>Final Amount (Rs.)</label>
              <input
                type="number"
                value={finalAmount}
                disabled
              />
            </div>




              {/* Payment Type */}
 <div className="form-group">
  <label>Payment Type</label>
  <select
    value={paymentType}
    onChange={(e) => setPaymentType(e.target.value)}
    required
  >
    <option value="">Select</option>
    <option value="full">Full Payment</option>
    <option value="advance">Advance and Settle</option>
    <option value="installment">Installment</option>
  </select>
</div>




{/* Advance Payment for Advance & Installment */}
{(paymentType === "advance" || paymentType === "installment") && (
  <div className="form-group">
    <label>Advance Payment (Rs.)</label>
    <input
      type="number"
      value={advancePayment}
      onChange={(e) => setAdvancePayment(e.target.value)}
      required
    />
  </div>
)}

              {/* Conditional Installment Fields */}
             {paymentType === "installment" && (
  <>
    <div className="form-group">
      <label>Installment Months</label>
      <input
        type="number"
        value={installmentMonths}
        onChange={(e) => setInstallmentMonths(e.target.value)}
        required
      />
    </div>

    <div className="form-group">
      <label>Each Installment Amount (Rs.)</label>
      <input
        type="number"
        value={eachInstallment}
        onChange={(e) => setEachInstallment(e.target.value)}
        required
      />
    </div>
  </>
)}



              {/* Remark */}
              <div className="form-group">
                <label>Remark</label>
                <textarea
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  rows="3"
                  placeholder="Optional remarks or notes"
                />
              </div>

              {/* Submit */}
              <button type="submit" className="submit-btn">
                Save Product
              </button>
            </form>
          </div>
        </div>
      )}


{/******************************************************************* View Added Products *************************************************************/}



{selectedOption === "viewAddedProduct" && (
 <div className="view-added-product-container">
          <h1 className="view-added-product-heading">View All Purchased Products</h1>

          {/* Filter Section */}
          <div className="filter-section">
            <input type="text" placeholder="Filter by Customer Name" value={filterName} onChange={(e) => setFilterName(e.target.value)} />
            <input type="text" placeholder="Filter by Company" value={filterCompany} onChange={(e) => setFilterCompany(e.target.value)} />
            <input type="number" placeholder="Min Price" value={filterMinPrice} onChange={(e) => setFilterMinPrice(e.target.value)} />
            <input type="number" placeholder="Max Price" value={filterMaxPrice} onChange={(e) => setFilterMaxPrice(e.target.value)} />
            <button onClick={fetchFilteredProducts}>Apply Filters</button>
            <button onClick={fetchAllProducts}>Clear Filters</button>
          </div>

          {/* Table */}
          <div className="product-table-container">
            <table className="product-table">
              <thead>
                <tr>
                  <th>Main Invoice No.</th>
                  <th>Customer Name</th>
                  <th>Email</th>
                  <th>Company</th>
                  <th>Product Name</th>
                  <th>Code</th>
                  <th>Qty</th>
                  <th>Unit Price</th>
                  <th>Total Amount</th>
                  <th>Payment Type</th>
                  <th>Advance</th>
                  <th>Months</th>
                  <th>Each</th>

                  <th>Remark</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {filteredProducts.length > 0 ? (
                  filteredProducts.map((product) => (
                    <tr key={product.id}>
                      <td>{product.invoiceNumber}</td>
                      <td>{product.customerName}</td>
                      <td>{product.email}</td>
                      <td>{product.company}</td>
                      <td>{product.productName}</td>
                      <td>{product.productCode}</td>
                      <td>{product.quantitySold}</td>
                      <td>{product.productPrice}</td>
                      <td>{product.finalAmount}</td>
                      <td>{product.paymentType}</td>
                      <td>{product.advancePayment || "-"}</td>
                      <td>{product.installmentMonths || "-"}</td>
                      <td>{product.eachInstallment || "-"}</td>
                      <td>{product.remark || "-"}</td>
                      <td>{product.date ? product.date.toLocaleString() : "-"}</td>
                      <td style={{ display: "flex", gap: "5px" }}>
                        <button style={{ background: "#4CAF50", color: "#fff" }} onClick={() => handleEdit(product)}>Edit</button>
                        <button style={{ background: "#023a7a", color: "#fff" }} onClick={() => handleDownload(product)}>Download</button>
                        <button style={{ background: "#f44336", color: "#fff" }} onClick={() => handlePurchasedProductDelete(product)}>Delete</button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="13" style={{ textAlign: "center", color: "#777" }}>No products found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Edit Modal */}
         {/* ✅ Edit Modal with All Fields */}
{showEditModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      <h2>Edit Product</h2>

      <div className="form-group">
        <label>Invoice Number:</label>
        <input
          type="text"
          name="invoiceNumber"
          value={editedData.invoiceNumber}
          onChange={handleEditChangeProduct}
          readOnly // Usually invoice number should not be edited
        />
      </div>

      <div className="form-group">
        <label>Date:</label>
        <input
          type="text"
          name="date"
          value={editedData.date}
          onChange={handleEditChangeProduct}
          readOnly
        />
      </div>

      <div className="form-group">
        <label>Customer Name:</label>
        <input
          type="text"
          name="customerName"
          value={editedData.customerName}
          onChange={handleEditChangeProduct}
        />
      </div>

      <div className="form-group">
        <label>Email:</label>
        <input
          type="email"
          name="email"
          value={editedData.email}
          onChange={handleEditChangeProduct}
        />
      </div>

      <div className="form-group">
        <label>Company:</label>
        <input
          type="text"
          name="company"
          value={editedData.company}
          onChange={handleEditChangeProduct}
        />
      </div>

      <div className="form-group">
        <label>Product Name:</label>
        <input
          type="text"
          name="productName"
          value={editedData.productName}
          onChange={handleEditChangeProduct}
        />
      </div>

      <div className="form-group">
        <label>Product Code:</label>
        <input
          type="text"
          name="productCode"
          value={editedData.productCode}
          onChange={handleEditChangeProduct}
        />
      </div>

      <div className="form-group">
        <label>Product Price (Rs.):</label>
        <input
          type="number"
          name="productPrice"
          value={editedData.productPrice}
          onChange={handleEditChangeProduct}
        />
      </div>

      <div className="form-group">
        <label>Payment Type:</label>
        <select
          name="paymentType"
          value={editedData.paymentType}
          onChange={handleEditChangeProduct}
        >
          <option value="">Select</option>
          <option value="full">Full Payment</option>
          <option value="installment">Installment</option>
        </select>
      </div>

      {/* ✅ Show only if payment type is installment */}
      {editedData.paymentType === "installment" && (
        <>
          <div className="form-group">
            <label>Advance Payment (Rs.):</label>
            <input
              type="number"
              name="advancePayment"
              value={editedData.advancePayment}
              onChange={handleEditChangeProduct}
            />
          </div>

          <div className="form-group">
            <label>Installment Months:</label>
            <input
              type="number"
              name="installmentMonths"
              value={editedData.installmentMonths}
              onChange={handleEditChangeProduct}
            />
          </div>

          <div className="form-group">
            <label>Each Installment (Rs.):</label>
            <input
              type="number"
              name="eachInstallment"
              value={editedData.eachInstallment}
              onChange={handleEditChangeProduct}
            />
          </div>
        </>
      )}

      <div className="form-group">
        <label>Remark:</label>
        <textarea
          name="remark"
          value={editedData.remark}
          onChange={handleEditChangeProduct}
        ></textarea>
      </div>

      <div className="modal-actions">
        <button onClick={handleSaveEdit} style={{ background: "#4CAF50", color: "#fff" }}>
          Save
        </button>
        <button onClick={() => setShowEditModal(false)} style={{ background: "#f44336", color: "#fff" }}>
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

        </div>
)}


{/******************************************************************* Add New Product *************************************************************/}

  {selectedOption === "addNewProduct" && (
        <div className="add-new-product-container">
          <h1>Add New Product</h1>
          <form onSubmit={handleSubmit} className="product-form">
            <div className="form-group">
              <label>Product Name *</label>
              <input
                type="text"
                name="productName"
                value={formData.productName}
                onChange={handleChange}
                placeholder="Enter product name"
              />
            </div>

            <div className="form-group">
              <label>Product Code *</label>
              <input
                type="text"
                name="productCode"
                value={formData.productCode}
                onChange={handleChange}
                placeholder="Enter product code"
              />
            </div>

            <div className="form-group">
              <label>Buying Price *</label>
              <input
                type="number"
                name="buyingPrice"
                value={formData.buyingPrice}
                onChange={handleChange}
                placeholder="Enter buying price"
              />
            </div>

            <div className="form-group">
              <label>Selling Price *</label>
              <input
                type="number"
                name="sellingPrice"
                value={formData.sellingPrice}
                onChange={handleChange}
                placeholder="Enter selling price"
              />
            </div>

            <div className="form-group">
              <label>Supplier *</label>
              <input
                type="text"
                name="supplier"
                value={formData.supplier}
                onChange={handleChange}
                placeholder="Enter supplier name"
              />
            </div>


            <div className="form-group">
              <label>Quantity *</label>
              <input
                type="number"
                name="quantity"
                value={formData.quantity}
                onChange={handleChange}
                placeholder="Enter available quantity"
                min="0"
              />
            </div>



            <div className="form-group">
              <label>Remark</label>
              <textarea
                name="remark"
                value={formData.remark}
                onChange={handleChange}
                placeholder="Optional remark..."
              />
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Saving..." : "Add Product"}
            </button>
          </form>

          {message && <p className="form-message">{message}</p>}
        </div>
      )}

{/******************************************************************* View payment *************************************************************/}

  {selectedOption === "viewAllProduct" && (
  <div className="view-all-products-container">

    <h1>View All Products</h1>

    {/* STOCK SUMMARY CONTAINER */}
    <div className="stock-summary-wrapper">

      <h2>Available Stock Summary</h2>

      <div className="stock-summary-scroll">

        <div className="stock-summary-grid">

          {stockSummary.map((item, index) => (
            <div key={index} className="stock-card">

              <h3>{item.productCode}</h3>
              <p>{item.productName}</p>

              <h2>Total Stock: {item.totalStock}</h2>

            </div>
          ))}

        </div>

      </div>

    </div>


    {/* TABLE CONTAINER */}
    {loading ? (
      <p>Loading products...</p>
    ) : products.length === 0 ? (
      <p>No products found.</p>
    ) : (

      <div className="table-scroll-container">

        <div className="table-wrapper">

          <table className="product-table">

            <thead>
              <tr>
                <th>Product Name</th>
                <th>Product Code</th>
                <th>Buying Price</th>
                <th>Selling Price</th>
                <th>Supplier</th>
                <th>Added Qty</th>
                <th>Available Qty</th>
                <th>Sold</th>
                <th>Date</th>
                <th>Remark</th>
                <th>Action</th>
              </tr>
            </thead>

                <tbody>
                  {products.map((product) => (
                    <tr key={product.id}>
                      <td>
                        {editingId === product.id ? (
                          <input
                            type="text"
                            name="productName"
                            value={editData.productName}
                            onChange={handleProductEditChange}
                          />
                        ) : (
                          product.productName
                        )}
                      </td>
                      <td>
                        {editingId === product.id ? (
                          <input
                            type="text"
                            name="productCode"
                            value={editData.productCode}
                            onChange={handleProductEditChange}
                          />
                        ) : (
                          product.productCode
                        )}
                      </td>
                      <td>
                        {editingId === product.id ? (
                          <input
                            type="number"
                            name="buyingPrice"
                            value={editData.buyingPrice}
                            onChange={handleProductEditChange}
                          />
                        ) : (
                          product.buyingPrice
                        )}
                      </td>
                      <td>
                        {editingId === product.id ? (
                          <input
                            type="number"
                            name="sellingPrice"
                            value={editData.sellingPrice}
                            onChange={handleProductEditChange}
                          />
                        ) : (
                          product.sellingPrice
                        )}
                      </td>
                      <td>
                        {editingId === product.id ? (
                          <input
                            type="text"
                            name="supplier"
                            value={editData.supplier}
                            onChange={handleProductEditChange}
                          />
                        ) : (
                          product.supplier
                        )}
                      </td>

{/* Added Quantity = sold + quantity */}
<td>
  {editingId === product.id ? (
    <input
      type="number"
      name="addedQuantity"
      value={
        editData.addedQuantity !== undefined
          ? editData.addedQuantity
          : (Number(editData.quantity) || 0) + (Number(editData.sold) || 0)
      }
      onChange={handleProductEditChange}
    />
  ) : (
    (Number(product.quantity) || 0) + (Number(product.sold) || 0)
  )}
</td>

{/* Quantity */}
<td>
  {editingId === product.id ? (
    <input
      type="number"
      name="quantity"
      value={editData.quantity || 0}
      onChange={handleProductEditChange}
    />
  ) : (
    product.quantity || 0
  )}
</td>

{/* Sold */}
<td>
  {editingId === product.id ? (
    <input
      type="number"
      name="sold"
      value={editData.sold || 0}
      onChange={handleProductEditChange}
    />
  ) : (
    product.sold || 0
  )}
</td>

        <td>
          {product.createdAt
            ? new Date(product.createdAt.seconds * 1000).toLocaleDateString()
            : "-"}
        </td>


                      <td>
                        {editingId === product.id ? (
                          <input
                            type="text"
                            name="remark"
                            value={editData.remark}
                            onChange={handleProductEditChange}
                          />
                        ) : (
                          product.remark
                        )}
                      </td>
                      <td>
                        {editingId === product.id ? (
                          <>
                            <button
                              className="save-btn"
                              onClick={() => handleSave(product.id)}
                            >
                              Save
                            </button>
                            <button
                              className="cancel-btn"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="edit-btn"
                              onClick={() => handleProductEdit(product)}
                            >
                              Edit
                            </button>
                            <button
                              className="delete-btn"
                              onClick={() => handleProductDelete(product.id)}
                            >
                              Delete
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

          </table>

        </div>

      </div>
    )}

  </div>
)}



{/******************************************************************* update payment *************************************************************/}

{selectedOption === "updatePayments" && (
  <>
  {/* ================= REPORT DOWNLOAD SECTION ================= */}
<div className="report-download-section">

  <h3>Download Payment Reports</h3>

  <div className="report-filters">


    {/* Buttons */}
    <div className="report-buttons">
      <button
        className="btn-download-report"
        onClick={downloadPaymentReport}
      >
        Download Excel Report
      </button>

     
    </div>
  </div>
</div>

    {selectedPurchase ? (
      // ===== Update Modal =====
      <div className="update-payment-modal-overlay">
        <div className="update-payment-modal-content">
          <h2>Update Payment</h2>
          <p className="payment-details">
            <strong>Main Invoice No:</strong> {selectedPurchase.invoiceNumber}<br />
            <strong>Customer:</strong> {selectedPurchase.customerName}<br />
            <strong>Company:</strong> {selectedPurchase.company}<br />
            <strong>Email:</strong> {selectedPurchase.email}<br />
            <strong>Product Code:</strong> {selectedPurchase.productCode}<br />
            <strong>Qty:</strong> {selectedPurchase.quantitySold}<br />
            <strong>Unit Price:</strong> Rs.{selectedPurchase.productPrice}<br />
            <strong>Total Amount:</strong> Rs.{selectedPurchase.finalAmount}<br />
            <strong>Advance Payment:</strong> Rs.{selectedPurchase.advancePayment || 0}<br />
            <strong>No. of Installments:</strong> {selectedPurchase.installmentMonths || "-"}<br />
            <strong>Each Installment:</strong> Rs.{selectedPurchase.eachInstallment || 0}<br />
            <strong>Installments Paid:</strong> {selectedPurchase.installmentsPaid || 0}<br />
            <strong>Total Installments Paid:</strong> Rs.{selectedPurchase.installmentsPaidAmount || 0}<br />
            <strong>Total Amount Paid:</strong> Rs.
            {(
              (selectedPurchase.advancePayment || 0) + 
              (selectedPurchase.installmentsPaidAmount || 0)
            ).toLocaleString()}<br />
            <strong>Outstanding Amount:</strong> Rs.
            {Math.max(
              (selectedPurchase.finalAmount || 0) -
              ((selectedPurchase.advancePayment || 0) + 
               (selectedPurchase.installmentsPaidAmount || 0)),
              0
            ).toFixed(2)}
          </p>



          <div className="update-payment-form-group">
            <label>Payment Date:</label>
            <input
              type="date"
              value={paymentData.paymentDate}
              onChange={(e) =>
                setPaymentData((prev) => ({ ...prev, paymentDate: e.target.value }))
              }
            />
          </div>

          <div className="update-payment-form-group">
            <label>Installment / Outstanding  (Rs.):</label>
            <input
              type="number"
              value={paymentData.installmentAmount}
              onChange={(e) =>
                setPaymentData((prev) => ({ ...prev, installmentAmount: e.target.value }))
              }
            />
          </div>

          <div className="update-payment-modal-actions">
            <button className="btn-save" onClick={() => handleSavePayment(selectedPurchase.id)}>
              Save Payment
            </button>
            <button className="btn-cancel" onClick={() => setSelectedPurchase(null)}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : (
      // ===== Main Table =====
      <div className="payment-update-container">
        <h1>Update Customer Payment</h1>

        {/* 🔍 Filter Section */}
        <div className="filter-section">
          <input
            type="text"
            placeholder="Search by Customer Name"
            value={filterName}
            onChange={(e) => setFilterName(e.target.value)}
          />
          <input
            type="text"
            placeholder="Search by Company"
            value={filterCompany}
            onChange={(e) => setFilterCompany(e.target.value)}
          />
          <input
            type="email"
            placeholder="Search by Email"
            value={filterEmail}
            onChange={(e) => setFilterEmail(e.target.value)}
          />
          <button onClick={fetchFilteredPurchases}>Search</button>
          <button onClick={fetchAllPurchases}>Clear</button>
        </div>

        {/* 📋 Table Section */}
        {loading ? (
          <p>Loading purchases...</p>
        ) : filteredPurchases.length === 0 ? (
          <p>No purchases found.</p>
        ) : (
          <div className="payment-table-container">
            <table className="payment-table">
              <thead>
                <tr>
                  <th>Main Invoice No</th>
                  <th>Customer Name</th>
                  <th>Company</th>
                  <th>Email</th>
                  <th>Product Name</th>
                  <th>Product Code</th>
                  <th>Qty</th>
                  <th>Unit Price (Rs.)</th>
                  <th>Total Amount</th>
                  <th>Payment Type</th>
                  <th>Advance (Rs.)</th>
                  <th>Advance Paid Date</th>
                  <th>No. of Installments</th>
                  <th>Each Installment (Rs.)</th>
                  <th>Installments Paid</th>
                  <th>Installments Amount (Rs.)</th>
                  <th>Total Paid (Rs.)</th>
                  <th>Outstanding (Rs.)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
               { (reportDate || reportMonth || reportYear
  ? reportFilteredData
  : filteredPurchases
).map((purchase) => {
                  const totalInstallmentsPaid = purchase.installmentsPaidAmount || 0;
                  const totalPaid = (purchase.advancePayment || 0) + totalInstallmentsPaid;
                  const outstanding = Math.max((purchase.finalAmount || 0) - totalPaid, 0);

                  return (
                    <tr key={purchase.id}>
                      <td>{purchase.invoiceNumber}</td>
                      <td>{purchase.customerName}</td>
                      <td>{purchase.company}</td>
                      <td>{purchase.email}</td>
                      <td>{purchase.productName}</td>
                      <td>{purchase.productCode}</td>
                      <td>{purchase.quantitySold}</td>
                      <td>{purchase.productPrice?.toLocaleString()}</td>
                      <td>{purchase.finalAmount}</td>
                      <td>{purchase.paymentType}</td>
                      <td>{(purchase.advancePayment || 0).toLocaleString()}</td>
                      {/* <td>{(purchase.date)}</td> */}
                     <td>{purchase.advancePayment > 0 ? purchase.date : "-"}</td>
                      <td>{purchase.installmentMonths || "-"}</td>
                      <td>{(purchase.eachInstallment || 0).toLocaleString()}</td>
                      <td>{purchase.installmentsPaid || 0}</td>
                      <td>{totalInstallmentsPaid.toLocaleString()}</td>
                      <td>{totalPaid.toLocaleString()}</td>
                      <td>{outstanding.toFixed(2)}</td>
                      <td className="actions">
            


<button
  className="btn-update"
  disabled={outstanding === 0}
  onClick={() => handleSelectPurchase(purchase)}
>
  Update
</button>

                        <button className="btn-download" onClick={() => downloadAllPayments(purchase)}>
                          Download All
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    )}
  </>
)}

{/******************************************************************* payments details ***********************************************************/}


{selectedOption === "paymentDetails" && (
<>
<div>
<div className="payment-details-filter">
  <input
    type="text"
    placeholder="Search by Customer Name"
    value={searchName}
    onChange={(e) => setSearchName(e.target.value)}
  />

  <input
    type="text"
    placeholder="Search by Email"
    value={searchEmail}
    onChange={(e) => setSearchEmail(e.target.value)}
  />

  <input
    type="text"
    placeholder="Search by Invoice Number"
    value={searchInvoice}
    onChange={(e) => setSearchInvoice(e.target.value)}
  />
</div>


<button className="clear-button-payment-details"
  onClick={() => {
    setSearchName("");
    setSearchEmail("");
    setSearchInvoice("");
  }}
>
  Clear
</button>
</div>

  <div className="customer-payment-details-container">
    <h1 className="customer-payment-details-title">
      Customer Payment Details
    </h1>








    {loading ? (
      <p>Loading payments...</p>
    ) : customerPayments.length === 0 ? (
      <p>No payment records found.</p>
    ) : (
      filteredCustomers.map((customer) => (
        <div
          key={customer.email}
          className="customer-payment-details-section"
        >
          <h2 className="customer-info-title">
            {customer.customerName} ({customer.email})
          </h2>
          {customer.purchases.map((purchase) => {
            // 🧾 Calculate outstanding based on payment type
            const outstanding =
              purchase.paymentType === "full"
                ? 0
                : (purchase.finalAmount || 0) -
                  ((purchase.advancePayment || 0) + (purchase.installmentsPaidAmount || 0));

            return (
              <div
                key={purchase.id}
                className="customer-product-payment-card"
              >
                <div className="customer-product-info">
                  <p><strong>Product:</strong> {purchase.productName}</p>
                  <p><strong>Product Code:</strong> {purchase.productCode}</p>
                  <p><strong>Main Invoice No:</strong> {purchase.invoiceNumber}</p>
                  <p><strong>Unit Price:</strong> Rs. {purchase.productPrice}</p>
                  <p><strong>Qty:</strong> {purchase.quantitySold}</p>
                  <p><strong>Total Amount:</strong> {purchase.finalAmount}</p>
                  <p><strong>Advance:</strong> Rs. {purchase.advancePayment}</p>
                  <p><strong>Outstanding:</strong> Rs. {outstanding}</p>
                </div>

                <div className="customer-payment-list">
 <table>
  <thead>
    <tr>
      <th>Sub Invoice No</th>
      <th>Payment Date</th>
      <th>Installment Amount</th>
    </tr>
  </thead>
  <tbody>
    {(purchase.payments || []).map((p) => (
      <tr key={p.id}>
        <td>{p.subInvoiceNumber}</td>
        <td>{p.paymentDate}</td>
        <td>Rs. {p.installmentAmount}</td>
      </tr>
    ))}
  </tbody>
</table>

                </div>
              </div>
            );
          })}
        </div>
      ))
    )}
  </div>
  </>
)}




{/***************************************************************************************************************************************/}


      </div>
    </div>
  );
};

export default AdminPanel;
